import axios from "axios";
import {
    EventResponseType,
    LoginResponseType,
    OfferResponseType,
    QrCodeResponseType,
    ResponseIType,
    RewardResponseType
} from "@/utils/general.type";
import store from "@/store";
import {MasterDataType, MemberDataType} from "@/store/store.type";
import {
    EventDetailType,
    EventType,
    OfferDetailType,
    OfferType,
    RewardDetailType,
    RewardType
} from "@/store/store.event.type";
import {sha512} from "js-sha512";
import i18n from "@/locales";
import router from "@/router";
import csv from "csvtojson";

// export const DOMAIN_ROOT = "http://localhost:3000";
export const DOMAIN_ROOT = `${window.location.protocol}//${window.location.host}${process.env.VUE_APP_BASE_URL}`;
const DOMAIN = DOMAIN_ROOT + '/handler.php';

export const route2Home = () => {
    router.push({
        name: 'Home',
        params: {
            lang: i18n.global.locale
        }
    });
}

export const getVICPrefix = (type: number): string => {
    return type === 1 ? "B" : (type === 2 ? "T" : "");
}

export const getVICPrefixByMemberClub = (memberClub: number): string => {
    return getVICPrefix(getTypeByMemberClub(memberClub));
}

export const getVICFullName = (type: number): string => {
    return type === 1 ? "Beauty " : (type === 2 ? "Tourist " : "");
}

export const getTypeByMemberClub = (memberClub: number): number => {
    return memberClub === 3 ? 1 : (memberClub === 6 ? 2 : 0);
}

export const getMemberClubByType = (type: number): number => {
    return type === 1 ? 3 : (type === 2 ? 6 : 2);
}

/**
 * @return 1: en, 2: zh, 3: sc
 */
export const getLanguageIntByLocale = (): number => {
    const localeString = i18n.global.locale;
    switch (localeString) {
        case 'zh':
            return 2;
        case 'sc':
            return 3;
        case "en-US":
        default:
            return 1;
    }
}

export const postLogin = async (email: string, password: string): Promise<void> => {
    const response = await axios.request({
        headers: {
            'Content-type': "application/x-www-form-urlencoded"
        },
        method: "POST",
        url: `${DOMAIN}?login`,
        data: JSON.stringify({
            EmailAddress: encodeURI(email),
            Password: sha512(password),
        })
    });

    const result = response.data as ResponseIType<LoginResponseType[]>;
    return await getLoginRequiredData(result.Data);
};

export const getLoginRequiredData = async (loginData: LoginResponseType[]): Promise<void> =>
    new Promise((resolve, reject) => {
        let count = 0;
        let rejected = false;
        const checkCount = () => {
            if (rejected) return;
            if (++count >= loginData.length) {
                resolve();
            }
        }
        // Language, MemberClub, MemberNo, SessionKey
        loginData.forEach((data: LoginResponseType) => {
            getProfile(data).then((res: MemberDataType) => {
                res.SessionKey = data.SessionKey;
                let singleClubCount = 0
                const onSingleClubReady = () => {
                    if (++singleClubCount === 4) {
                        store.commit('onLogin', res);
                        checkCount();
                    }
                }

                getQRCode(data).then((qrCode: string) => {
                    res.QrCode = qrCode;
                }).finally(onSingleClubReady);

                getRewardList(data.MemberClub).then((list: RewardType[]) => {
                    res.rewards = list;
                }).finally(onSingleClubReady);

                getOfferList(data.MemberClub, res.ProfileDetails.MemberTierId)
                    .then((list: OfferType[]) => {
                        res.privileges = list.filter((item: OfferType) => item.Type === 3);
                        res.bDayOffer = list.filter((item: OfferType) => item.Type === 4);
                    }).finally(onSingleClubReady);

                getEventList(data, res.ProfileDetails.MemberTierId)
                    .then((list: EventType[]) => {
                        res.happenings = list;
                    }).finally(onSingleClubReady);

            }).catch((err: Error) => {
                rejected = true;
                reject(err);
                checkCount();
            })
        })
    });

const getProfile = (loginData: LoginResponseType) => new Promise<MemberDataType>((resolve, reject) => {
    axios.post(`${DOMAIN}?profile`, {
        Language: getLanguageIntByLocale(),
        MemberClub: loginData.MemberClub,
        MemberNo: loginData.MemberNo,
        SessionKey: loginData.SessionKey,
    }).then((response) => {
        const result = response.data as ResponseIType<MemberDataType>;
        resolve(result.Data);
    }).catch((err: Error) => {
        console.error(err);
        reject(err);
    })
})

const getQRCode = (loginData: LoginResponseType) =>
    new Promise<string>((resolve, reject) => {
        // resolve("2gCjTHHg4JXaO8ia8vId4YWVHbdzzXjWX6IeizHBe+s=");
        axios.post(`${DOMAIN}?qr-code`, {
            Language: getLanguageIntByLocale(),
            MemberClub: loginData.MemberClub,
            MemberNo: loginData.MemberNo,
        }).then((response) => {
            const result = response.data as ResponseIType<QrCodeResponseType>;
            resolve(result.Data.QrCode);
        }).catch((err: Error) => {
            console.error(err);
            reject(err);
        })
    })

const getRewardList = (memberClub: number) =>
    new Promise<RewardType[]>((resolve, reject) => {
        // resolve(
        //     [
        //         {
        //             "RewardId": "TVR102292",
        //             "MemberClub": 2,
        //             "BrandName": "",
        //             "Name": "Bookazine $100 Voucher",
        //             "InternalName": "Bookazine $100 Voucher",
        //             "EffectiveFrom": "2022-03-01",
        //             "EffectiveTo": "2022-03-31",
        //             "Quantity": 100,
        //             "PointsToRedeem": 25000,
        //             "ImageURL": "https://wraextprosto.z7.web.core.windows.net/995C971F-A0E6-EA11-A817-000D3A856750_202008251613377265.jpg",
        //             "IconURL": "https://wraextprosto.z7.web.core.windows.net/995C971F-A0E6-EA11-A817-000D3A856750_202008251613377265.jpg",
        //             "StockLevel": "In Stock",
        //             "DisplayColor": null,
        //             "GiftCoupon": 2,
        //             "Reminder": false,
        //             "Tags": "",
        //             "AllowAppRedemption": false,
        //             "DisplayUseNow": false,
        //             "FaceAmount": 0
        //         },
        //         {
        //             "RewardId": "TVR102290",
        //             "MemberClub": 2,
        //             "BrandName": "",
        //             "Name": "Designated Sake",
        //             "InternalName": "Designated Sake",
        //             "EffectiveFrom": "2022-03-01",
        //             "EffectiveTo": "2022-03-31",
        //             "Quantity": 98,
        //             "PointsToRedeem": 25000,
        //             "ImageURL": "https://wraextprosto.z7.web.core.windows.net/7F82B82A-E87F-EC11-8D21-002248174DCD_202201281156445203.jpg",
        //             "IconURL": "---https://wraextprosto.z7.web.core.windows.net/7F82B82A-E87F-EC11-8D21-002248174DCD_202201281156445203.jpg",
        //             "StockLevel": "In Stock",
        //             "DisplayColor": null,
        //             "GiftCoupon": 1,
        //             "Reminder": false,
        //             "Tags": "",
        //             "AllowAppRedemption": false,
        //             "DisplayUseNow": false,
        //             "FaceAmount": 0
        //         },
        //         {
        //             "RewardId": "TVR102291",
        //             "MemberClub": 2,
        //             "BrandName": "",
        //             "Name": "Shake Shack Burger & Shake Voucher",
        //             "InternalName": "Shake Shack Burger & Shake Voucher",
        //             "EffectiveFrom": "2022-03-01",
        //             "EffectiveTo": "2022-03-31",
        //             "Quantity": 97,
        //             "PointsToRedeem": 25000,
        //             "ImageURL": "https://wraextprosto.z7.web.core.windows.net/413E2871-E87F-EC11-8D21-002248174DCD_202201281201547030.jpg",
        //             "IconURL": "https://wraextprosto.z7.web.core.windows.net/413E2871-E87F-EC11-8D21-002248174DCD_202201281201547030.jpg",
        //             "StockLevel": "In Stock",
        //             "DisplayColor": null,
        //             "GiftCoupon": 2,
        //             "Reminder": false,
        //             "Tags": "",
        //             "AllowAppRedemption": false,
        //             "DisplayUseNow": false,
        //             "FaceAmount": 0
        //         },
        //         {
        //             "RewardId": "TVR102289",
        //             "MemberClub": 2,
        //             "BrandName": "",
        //             "Name": "Starbucks $100 Gift Card",
        //             "InternalName": "Starbucks $100 Gift Card",
        //             "EffectiveFrom": "2022-03-01",
        //             "EffectiveTo": "2022-03-31",
        //             "Quantity": 94,
        //             "PointsToRedeem": 25000,
        //             "ImageURL": "https://wraextprosto.z7.web.core.windows.net/F8A585E5-E77F-EC11-8D21-002248174DCD_202201281202438700.jpg",
        //             "IconURL": "https://wraextprosto.z7.web.core.windows.net/F8A585E5-E77F-EC11-8D21-002248174DCD_202201281202438700.jpg",
        //             "StockLevel": "In Stock",
        //             "DisplayColor": null,
        //             "GiftCoupon": 2,
        //             "Reminder": false,
        //             "Tags": "",
        //             "AllowAppRedemption": false,
        //             "DisplayUseNow": false,
        //             "FaceAmount": 0
        //         },
        //         {
        //             "RewardId": "TVR102293",
        //             "MemberClub": 2,
        //             "BrandName": "",
        //             "Name": "city'super $100 Voucher",
        //             "InternalName": "city'super $100 Voucher",
        //             "EffectiveFrom": "2022-03-01",
        //             "EffectiveTo": "2022-03-31",
        //             "Quantity": 84,
        //             "PointsToRedeem": 30000,
        //             "ImageURL": "https://wraextprosto.z7.web.core.windows.net/A00928A4-E87F-EC11-8D21-002248174DCD_202201281152021488.jpg",
        //             "IconURL": "https://wraextprosto.z7.web.core.windows.net/A00928A4-E87F-EC11-8D21-002248174DCD_202201281152021488.jpg",
        //             "StockLevel": "In Stock",
        //             "DisplayColor": null,
        //             "GiftCoupon": 2,
        //             "Reminder": false,
        //             "Tags": "",
        //             "AllowAppRedemption": false,
        //             "DisplayUseNow": false,
        //             "FaceAmount": 0
        //         },
        //         {
        //             "RewardId": "TVR102295",
        //             "MemberClub": 2,
        //             "BrandName": "",
        //             "Name": "Broadway $300 Gift Card",
        //             "InternalName": "Broadway $300 Gift Card",
        //             "EffectiveFrom": "2022-03-01",
        //             "EffectiveTo": "2022-03-31",
        //             "Quantity": 98,
        //             "PointsToRedeem": 50000,
        //             "ImageURL": "https://wraextprosto.z7.web.core.windows.net/E1AFD7D5-E87F-EC11-8D21-002248174DCD_202201281151047632.jpg",
        //             "IconURL": "https://wraextprosto.z7.web.core.windows.net/E1AFD7D5-E87F-EC11-8D21-002248174DCD_202201281151047632.jpg",
        //             "StockLevel": "In Stock",
        //             "DisplayColor": null,
        //             "GiftCoupon": 2,
        //             "Reminder": false,
        //             "Tags": "",
        //             "AllowAppRedemption": false,
        //             "DisplayUseNow": false,
        //             "FaceAmount": 0
        //         },
        //         {
        //             "RewardId": "TVR102294",
        //             "MemberClub": 2,
        //             "BrandName": "",
        //             "Name": "Victorinox Table Set (knife, fork & spoon)",
        //             "InternalName": "Victorinox Table Set (knife, fork & spoon)",
        //             "EffectiveFrom": "2022-03-01",
        //             "EffectiveTo": "2022-03-31",
        //             "Quantity": 99,
        //             "PointsToRedeem": 50000,
        //             "ImageURL": "https://d15k2d11r6t6rl.cloudfront.net/public/users/Integrators/30362ec0-6160-4873-be5a-3b39551a5a27/5f55e38f47b88438b2d089b9/623755_vic.jpg",
        //             "IconURL": "https://d15k2d11r6t6rl.cloudfront.net/public/users/Integrators/30362ec0-6160-4873-be5a-3b39551a5a27/5f55e38f47b88438b2d089b9/623755_vic.jpg",
        //             "StockLevel": "In Stock",
        //             "DisplayColor": null,
        //             "GiftCoupon": 1,
        //             "Reminder": false,
        //             "Tags": "",
        //             "AllowAppRedemption": false,
        //             "DisplayUseNow": false,
        //             "FaceAmount": 0
        //         },
        //         {
        //             "RewardId": "TVR102298",
        //             "MemberClub": 2,
        //             "BrandName": "",
        //             "Name": "city'super $300 Voucher",
        //             "InternalName": "city'super $300 Voucher",
        //             "EffectiveFrom": "2022-03-01",
        //             "EffectiveTo": "2022-03-31",
        //             "Quantity": 83,
        //             "PointsToRedeem": 70000,
        //             "ImageURL": "https://wraextprosto.z7.web.core.windows.net/A00928A4-E87F-EC11-8D21-002248174DCD_202201281152021488.jpg",
        //             "IconURL": "https://wraextprosto.z7.web.core.windows.net/A00928A4-E87F-EC11-8D21-002248174DCD_202201281152021488.jpg",
        //             "StockLevel": "In Stock",
        //             "DisplayColor": null,
        //             "GiftCoupon": 2,
        //             "Reminder": false,
        //             "Tags": "",
        //             "AllowAppRedemption": false,
        //             "DisplayUseNow": false,
        //             "FaceAmount": 0
        //         },
        //         {
        //             "RewardId": "TVR102297",
        //             "MemberClub": 2,
        //             "BrandName": "",
        //             "Name": "CULTI MILANO Home Diffuser",
        //             "InternalName": "CULTI MILANO Home Diffuser",
        //             "EffectiveFrom": "2022-03-01",
        //             "EffectiveTo": "2022-03-31",
        //             "Quantity": 99,
        //             "PointsToRedeem": 70000,
        //             "ImageURL": "https://wraextprosto.z7.web.core.windows.net/1B9A16FA-2969-EC11-8943-000D3A817E3F_202112301843329589.jpg",
        //             "IconURL": "https://wraextprosto.z7.web.core.windows.net/1B9A16FA-2969-EC11-8943-000D3A817E3F_202112301843329589.jpg",
        //             "StockLevel": "In Stock",
        //             "DisplayColor": null,
        //             "GiftCoupon": 1,
        //             "Reminder": false,
        //             "Tags": "",
        //             "AllowAppRedemption": false,
        //             "DisplayUseNow": false,
        //             "FaceAmount": 0
        //         },
        //         {
        //             "RewardId": "TVR102296",
        //             "MemberClub": 2,
        //             "BrandName": "",
        //             "Name": "Jo Malone London Cologne 30ml",
        //             "InternalName": "Jo Malone London Cologne 30ml",
        //             "EffectiveFrom": "2022-03-01",
        //             "EffectiveTo": "2022-03-31",
        //             "Quantity": 100,
        //             "PointsToRedeem": 70000,
        //             "ImageURL": "https://wraextprosto.z7.web.core.windows.net/5DC7FD46-1097-EC11-B400-0022481776E7_202202281036080290.png",
        //             "IconURL": "https://wraextprosto.z7.web.core.windows.net/5DC7FD46-1097-EC11-B400-0022481776E7_202202281036080290.png",
        //             "StockLevel": "In Stock",
        //             "DisplayColor": null,
        //             "GiftCoupon": 1,
        //             "Reminder": false,
        //             "Tags": "",
        //             "AllowAppRedemption": false,
        //             "DisplayUseNow": false,
        //             "FaceAmount": 0
        //         },
        //         {
        //             "RewardId": "TVR102299",
        //             "MemberClub": 2,
        //             "BrandName": "",
        //             "Name": "Broadway $500 Gift Card & city'super $100 Voucher",
        //             "InternalName": "Broadway $500 Gift Card & city'super $100 Voucher",
        //             "EffectiveFrom": "2022-03-01",
        //             "EffectiveTo": "2022-03-31",
        //             "Quantity": 89,
        //             "PointsToRedeem": 90000,
        //             "ImageURL": "https://wraextprosto.z7.web.core.windows.net/06A6DBF9-E97F-EC11-8D21-002248174DCD_202201281149515626.jpg",
        //             "IconURL": "https://wraextprosto.z7.web.core.windows.net/06A6DBF9-E97F-EC11-8D21-002248174DCD_202201281149515626.jpg",
        //             "StockLevel": "In Stock",
        //             "DisplayColor": null,
        //             "GiftCoupon": 2,
        //             "Reminder": false,
        //             "Tags": "",
        //             "AllowAppRedemption": false,
        //             "DisplayUseNow": false,
        //             "FaceAmount": 0
        //         },
        //         {
        //             "RewardId": "TVR102300",
        //             "MemberClub": 2,
        //             "BrandName": "",
        //             "Name": "Lane Crawford $1,000 Gift Card & city'super $100 Voucher",
        //             "InternalName": "Lane Crawford $1,000 Gift Card & city'super $100 Voucher",
        //             "EffectiveFrom": "2022-03-01",
        //             "EffectiveTo": "2022-03-31",
        //             "Quantity": 94,
        //             "PointsToRedeem": 150000,
        //             "ImageURL": "https://wraextprosto.z7.web.core.windows.net/E123CD1F-EA7F-EC11-8D21-002248174DCD_202201281157583340.jpg",
        //             "IconURL": "https://wraextprosto.z7.web.core.windows.net/E123CD1F-EA7F-EC11-8D21-002248174DCD_202201281157583340.jpg",
        //             "StockLevel": "In Stock",
        //             "DisplayColor": null,
        //             "GiftCoupon": 2,
        //             "Reminder": false,
        //             "Tags": "",
        //             "AllowAppRedemption": false,
        //             "DisplayUseNow": false,
        //             "FaceAmount": 0
        //         },
        //         {
        //             "RewardId": "TVR102301",
        //             "MemberClub": 2,
        //             "BrandName": "",
        //             "Name": "Lane Crawford $5,000 Gift Card",
        //             "InternalName": "Lane Crawford $5,000 Gift Card",
        //             "EffectiveFrom": "2022-03-01",
        //             "EffectiveTo": "2022-03-31",
        //             "Quantity": 92,
        //             "PointsToRedeem": 500000,
        //             "ImageURL": "https://wraextprosto.z7.web.core.windows.net/831C09E7-4BF0-EB11-94EF-000D3A81FD58_202107291845348435.jpg",
        //             "IconURL": "https://wraextprosto.z7.web.core.windows.net/831C09E7-4BF0-EB11-94EF-000D3A81FD58_202107291845348435.jpg",
        //             "StockLevel": "In Stock",
        //             "DisplayColor": null,
        //             "GiftCoupon": 2,
        //             "Reminder": false,
        //             "Tags": "",
        //             "AllowAppRedemption": false,
        //             "DisplayUseNow": false,
        //             "FaceAmount": 0
        //         }
        //     ]
        // );
        axios.post(`${DOMAIN}?reward-list`, {
            Language: getLanguageIntByLocale(),
            MemberClub: memberClub,
        }).then((response) => {
            const result = response.data as ResponseIType<RewardResponseType>;
            resolve(result.Data.Rewards);
        }).catch((err: Error) => {
            console.error(err);
            reject(err);
        })
    })

const getOfferList = (memberClub: number, memberTierId: string) =>
    new Promise<OfferType[]>((resolve, reject) => {
        // resolve([
        //     {
        //         "ExclusiveOfferId": "34728c9e-dc62-ec11-8f8f-00224816ce4a",
        //         "MemberClub": 2,
        //         "MemberTier": "Black",
        //         "MemberTierId": "83bd3439-74e3-ea11-a813-000d3a8287a9",
        //         "Type": 3,
        //         "Name": "3CE Stylenanda",
        //         "Description": "1. 10% off on selected regular-priced items\n2. Extra 5% off on discounted items    ",
        //         "From": "2022-01-01",
        //         "To": "2022-06-30",
        //         "ImageURL": "https://wraextprosto.z7.web.core.windows.net/34728C9E-DC62-EC11-8F8F-00224816CE4A_202112221207338030.jpg",
        //         "PosterImageURL": "",
        //         "Tags": "Shopping"
        //     },
        //     {
        //         "ExclusiveOfferId": "a241f900-dd62-ec11-8f8f-00224816ce4a",
        //         "MemberClub": 2,
        //         "MemberTier": "Black",
        //         "MemberTierId": "83bd3439-74e3-ea11-a813-000d3a8287a9",
        //         "Type": 3,
        //         "Name": "ARTĒ Madrid",
        //         "Description": "1. Enjoy a $300 shopping discount\n2. Receive a complimentary 1 carat ARTE Madrid 120-facet stone upon purchase of regular-priced jewellery item",
        //         "From": "2022-01-01",
        //         "To": "2022-06-30",
        //         "ImageURL": "https://wraextprosto.z7.web.core.windows.net/0877A4B7-4F4A-EB11-A812-000D3A82FBCB_202012301133184938.jpg",
        //         "PosterImageURL": "",
        //         "Tags": "Shopping"
        //     },
        //     {
        //         "ExclusiveOfferId": "6f8e33b9-dd62-ec11-8f8f-00224816ce4a",
        //         "MemberClub": 2,
        //         "MemberTier": "Black",
        //         "MemberTierId": "83bd3439-74e3-ea11-a813-000d3a8287a9",
        //         "Type": 3,
        //         "Name": "Atsuro Tayama",
        //         "Description": "10% off on regular priced items",
        //         "From": "2022-01-01",
        //         "To": "2022-06-30",
        //         "ImageURL": "https://wraextprosto.z7.web.core.windows.net/571D4445-AC49-EB11-A812-000D3A82FBCB_202012291614283502.jpg",
        //         "PosterImageURL": "",
        //         "Tags": "Shopping"
        //     },
        //     {
        //         "ExclusiveOfferId": "0dbc6f32-df62-ec11-8f8f-00224816ce4a",
        //         "MemberClub": 2,
        //         "MemberTier": "Black",
        //         "MemberTierId": "83bd3439-74e3-ea11-a813-000d3a8287a9",
        //         "Type": 3,
        //         "Name": "Bakebe",
        //         "Description": "10% discount for regular priced baking courses ",
        //         "From": "2022-01-01",
        //         "To": "2022-06-30",
        //         "ImageURL": "https://wraextprosto.z7.web.core.windows.net/9F4CD413-AD49-EB11-A812-000D3A82FBCB_202012291609022714.jpg",
        //         "PosterImageURL": "",
        //         "Tags": "Shopping"
        //     },
        //     {
        //         "ExclusiveOfferId": "7e414a85-df62-ec11-8f8f-00224816ce4a",
        //         "MemberClub": 2,
        //         "MemberTier": "Black",
        //         "MemberTierId": "83bd3439-74e3-ea11-a813-000d3a8287a9",
        //         "Type": 3,
        //         "Name": "banchan & Cook",
        //         "Description": "10% off upon any consumption (Dine-in only) from Monday to Saturday (except Public Holidays)",
        //         "From": "2022-01-01",
        //         "To": "2022-06-30",
        //         "ImageURL": "https://wraextprosto.z7.web.core.windows.net/0530B948-AE49-EB11-A812-000D3A82FBCB_202012291617432427.jpg",
        //         "PosterImageURL": "",
        //         "Tags": "Dining"
        //     },
        //     {
        //         "ExclusiveOfferId": "9218952f-e062-ec11-8f8f-00224816ce4a",
        //         "MemberClub": 2,
        //         "MemberTier": "Black",
        //         "MemberTierId": "83bd3439-74e3-ea11-a813-000d3a8287a9",
        //         "Type": 3,
        //         "Name": "Caffe Milani",
        //         "Description": "15% off for any order of whole cake",
        //         "From": "2022-01-01",
        //         "To": "2022-06-30",
        //         "ImageURL": "https://wraextprosto.z7.web.core.windows.net/116A2D53-3FC4-EB11-BACC-002248171BE2_202106031543396896.jpg",
        //         "PosterImageURL": "",
        //         "Tags": "Dining"
        //     },
        //     {
        //         "ExclusiveOfferId": "7f488a5c-e162-ec11-8f8f-00224816ce4a",
        //         "MemberClub": 2,
        //         "MemberTier": "Black",
        //         "MemberTierId": "83bd3439-74e3-ea11-a813-000d3a8287a9",
        //         "Type": 3,
        //         "Name": "Chow Tai Fook",
        //         "Description": "1. Enjoy 20% off on Craftsmanship & Design fee of Pure Gold products\n2. Enjoy the purchase of a selected jewellery product in redemption price",
        //         "From": "2022-01-01",
        //         "To": "2022-06-30",
        //         "ImageURL": "https://wracmsuatsto.blob.core.windows.net/assets/Chow%20Tai%20Fook.jpg",
        //         "PosterImageURL": "",
        //         "Tags": "Shopping"
        //     },
        //     {
        //         "ExclusiveOfferId": "e88be6e9-e262-ec11-8f8f-00224816ce4a",
        //         "MemberClub": 2,
        //         "MemberTier": "Black",
        //         "MemberTierId": "83bd3439-74e3-ea11-a813-000d3a8287a9",
        //         "Type": 3,
        //         "Name": "city’super",
        //         "Description": "1. Enjoy 3% discount on Florté regular-priced items\n2. Enjoy 3% discount on Hang Hing regular-priced items\n3. Enjoy 3% discount on Ying Kee Tea House regular-priced items",
        //         "From": "2022-01-01",
        //         "To": "2022-06-30",
        //         "ImageURL": "https://wraextprosto.z7.web.core.windows.net/5BD8C390-3062-EC11-8F8F-00224816CE4A_202201041240370641.jpg",
        //         "PosterImageURL": "",
        //         "Tags": "Shopping"
        //     },
        //     {
        //         "ExclusiveOfferId": "f815412d-e362-ec11-8f8f-00224816ce4a",
        //         "MemberClub": 2,
        //         "MemberTier": "Black",
        //         "MemberTierId": "83bd3439-74e3-ea11-a813-000d3a8287a9",
        //         "Type": 3,
        //         "Name": "Claudie Pierlot",
        //         "Description": "Receive a complimentary gift on upon the first time purchase on regular-priced items only",
        //         "From": "2022-01-01",
        //         "To": "2022-06-30",
        //         "ImageURL": "https://wracmsuatsto.blob.core.windows.net/assets/5e4e582eddb7.jpg",
        //         "PosterImageURL": "",
        //         "Tags": "Shopping"
        //     },
        //     {
        //         "ExclusiveOfferId": "e6daa2b3-e362-ec11-8f8f-00224816ce4a",
        //         "MemberClub": 2,
        //         "MemberTier": "Black",
        //         "MemberTierId": "83bd3439-74e3-ea11-a813-000d3a8287a9",
        //         "Type": 3,
        //         "Name": "Clinique",
        //         "Description": "Receive a complimentary skincare & makeup set (worth $210) upon joining as Clinique member",
        //         "From": "2022-01-01",
        //         "To": "2022-06-30",
        //         "ImageURL": "https://wraextprosto.z7.web.core.windows.net/62D76BE4-634A-EB11-A812-000D3A82FBCB_202012301357368551.jpeg",
        //         "PosterImageURL": "",
        //         "Tags": "Shopping"
        //     },
        //     {
        //         "ExclusiveOfferId": "d73cc8ff-e362-ec11-8f8f-00224816ce4a",
        //         "MemberClub": 2,
        //         "MemberTier": "Black",
        //         "MemberTierId": "83bd3439-74e3-ea11-a813-000d3a8287a9",
        //         "Type": 3,
        //         "Name": "Club Monaco",
        //         "Description": "Enjoy 5% off upon spending $3800 or above on regular items in a single transaction",
        //         "From": "2022-01-01",
        //         "To": "2022-06-30",
        //         "ImageURL": "https://wraextprosto.z7.web.core.windows.net/6C71E246-B049-EB11-A812-000D3A82FBCB_202012291631533665.jpg",
        //         "PosterImageURL": "",
        //         "Tags": "Shopping"
        //     },
        //     {
        //         "ExclusiveOfferId": "cb516e54-e462-ec11-8f8f-00224816ce4a",
        //         "MemberClub": 2,
        //         "MemberTier": "Black",
        //         "MemberTierId": "83bd3439-74e3-ea11-a813-000d3a8287a9",
        //         "Type": 3,
        //         "Name": "ecco",
        //         "Description": "10% discount on regular shoes",
        //         "From": "2022-01-01",
        //         "To": "2022-06-30",
        //         "ImageURL": "https://wracmsdevsto.z23.web.core.windows.net/6A206AD2-EF44-EB11-A812-000D3A8241A6_202012231524117157.jpg",
        //         "PosterImageURL": "",
        //         "Tags": "Shopping"
        //     },
        //     {
        //         "ExclusiveOfferId": "55dc4db9-e462-ec11-8f8f-00224816ce4a",
        //         "MemberClub": 2,
        //         "MemberTier": "Black",
        //         "MemberTierId": "83bd3439-74e3-ea11-a813-000d3a8287a9",
        //         "Type": 3,
        //         "Name": "Elegant Watch & Jewellery",
        //         "Description": "Receive a complimentary gift upon purchase of HK$50,000",
        //         "From": "2022-01-01",
        //         "To": "2022-06-30",
        //         "ImageURL": "https://wraextprosto.z7.web.core.windows.net/3C116B07-B249-EB11-A812-000D3A82FBCB_202012291644297593.jpg",
        //         "PosterImageURL": "",
        //         "Tags": "Shopping"
        //     },
        //     {
        //         "ExclusiveOfferId": "84d8be0b-e562-ec11-8f8f-00224816ce4a",
        //         "MemberClub": 2,
        //         "MemberTier": "Black",
        //         "MemberTierId": "83bd3439-74e3-ea11-a813-000d3a8287a9",
        //         "Type": 3,
        //         "Name": "ÉLÉVATIONE",
        //         "Description": "1. Redeem a complimentary Delux Sample Pack\n2. Enjoy special price at $688 to purchase Preserve Pure Excellence Peeling Gel \n(Original Price $1,380)",
        //         "From": "2022-01-01",
        //         "To": "2022-06-30",
        //         "ImageURL": "https://wraextprosto.z7.web.core.windows.net/7167228D-5C4A-EB11-A812-000D3A82FBCB_202012301305024597.jpg",
        //         "PosterImageURL": "",
        //         "Tags": "Shopping"
        //     },
        //     {
        //         "ExclusiveOfferId": "f084ab59-e562-ec11-8f8f-00224816ce4a",
        //         "MemberClub": 2,
        //         "MemberTier": "Black",
        //         "MemberTierId": "83bd3439-74e3-ea11-a813-000d3a8287a9",
        //         "Type": 3,
        //         "Name": "EVE LOM",
        //         "Description": "Receive a complimentary Cleanser 5ml (with Muslin Cloth)",
        //         "From": "2022-01-01",
        //         "To": "2022-06-30",
        //         "ImageURL": "https://wraextprosto.z7.web.core.windows.net/D44AD429-5D4A-EB11-A812-000D3A82FBCB_202012301309325867.jpg",
        //         "PosterImageURL": "",
        //         "Tags": "Shopping"
        //     },
        //     {
        //         "ExclusiveOfferId": "863cf99d-e562-ec11-8f8f-00224816ce4a",
        //         "MemberClub": 2,
        //         "MemberTier": "Black",
        //         "MemberTierId": "83bd3439-74e3-ea11-a813-000d3a8287a9",
        //         "Type": 3,
        //         "Name": "FIVE CM",
        //         "Description": "1. 10% off on selected regular-priced items\n2. Extra 5% off on discounted items    ",
        //         "From": "2022-01-01",
        //         "To": "2022-06-30",
        //         "ImageURL": "https://wraextprosto.z7.web.core.windows.net/BF90C2BE-B349-EB11-A812-000D3A82FBCB_202012291656409126.jpg",
        //         "PosterImageURL": "",
        //         "Tags": "Shopping"
        //     },
        //     {
        //         "ExclusiveOfferId": "955dfef0-e562-ec11-8f8f-00224816ce4a",
        //         "MemberClub": 2,
        //         "MemberTier": "Black",
        //         "MemberTierId": "83bd3439-74e3-ea11-a813-000d3a8287a9",
        //         "Type": 3,
        //         "Name": "Fred Perry",
        //         "Description": "1. 10% off on selected regular-priced items\n2. Extra 5% off on discounted items    ",
        //         "From": "2022-01-01",
        //         "To": "2022-06-30",
        //         "ImageURL": "https://wraextprosto.z7.web.core.windows.net/AC0024E0-B449-EB11-A812-000D3A82FBCB_202012291704549134.jpg",
        //         "PosterImageURL": "",
        //         "Tags": "Shopping"
        //     },
        //     {
        //         "ExclusiveOfferId": "e027df3e-e662-ec11-8f8f-00224816ce4a",
        //         "MemberClub": 2,
        //         "MemberTier": "Black",
        //         "MemberTierId": "83bd3439-74e3-ea11-a813-000d3a8287a9",
        //         "Type": 3,
        //         "Name": "Furla",
        //         "Description": "5% off on selected regular-priced items",
        //         "From": "2022-01-01",
        //         "To": "2022-06-30",
        //         "ImageURL": "https://wraextprosto.z7.web.core.windows.net/D53AAD52-B549-EB11-A812-000D3A82FBCB_202012291708189916.jpg",
        //         "PosterImageURL": "",
        //         "Tags": "Shopping"
        //     },
        //     {
        //         "ExclusiveOfferId": "9c873886-e662-ec11-8f8f-00224816ce4a",
        //         "MemberClub": 2,
        //         "MemberTier": "Black",
        //         "MemberTierId": "83bd3439-74e3-ea11-a813-000d3a8287a9",
        //         "Type": 3,
        //         "Name": "GREENHOUSE",
        //         "Description": "20% off on Specially Cake Collection",
        //         "From": "2022-01-01",
        //         "To": "2022-06-30",
        //         "ImageURL": "https://wraextprosto.z7.web.core.windows.net/7B911ABC-B549-EB11-A812-000D3A82FBCB_202012291713402661.jpg",
        //         "PosterImageURL": "",
        //         "Tags": "Shopping"
        //     },
        //     {
        //         "ExclusiveOfferId": "fa187fdb-e662-ec11-8f8f-00224816ce4a",
        //         "MemberClub": 2,
        //         "MemberTier": "Black",
        //         "MemberTierId": "83bd3439-74e3-ea11-a813-000d3a8287a9",
        //         "Type": 3,
        //         "Name": "Greyhound Café",
        //         "Description": "20% off on Specially Cake Collection",
        //         "From": "2022-01-01",
        //         "To": "2022-06-30",
        //         "ImageURL": "https://wraextprosto.z7.web.core.windows.net/9E789077-B649-EB11-A812-000D3A82FBCB_202103041630294387.jpg",
        //         "PosterImageURL": "",
        //         "Tags": "Dining"
        //     },
        //     {
        //         "ExclusiveOfferId": "cfe3111b-e762-ec11-8f8f-00224816ce4a",
        //         "MemberClub": 2,
        //         "MemberTier": "Black",
        //         "MemberTierId": "83bd3439-74e3-ea11-a813-000d3a8287a9",
        //         "Type": 3,
        //         "Name": "Her own words",
        //         "Description": "5% discount on regular-priced items",
        //         "From": "2022-01-01",
        //         "To": "2022-06-30",
        //         "ImageURL": "https://wraextprosto.z7.web.core.windows.net/8D287A65-1FF4-EB11-94EF-000D3A8043B3_202108041648590476.jpg",
        //         "PosterImageURL": "",
        //         "Tags": "Shopping"
        //     },
        //     {
        //         "ExclusiveOfferId": "0b222b92-e762-ec11-8f8f-00224816ce4a",
        //         "MemberClub": 2,
        //         "MemberTier": "Black",
        //         "MemberTierId": "83bd3439-74e3-ea11-a813-000d3a8287a9",
        //         "Type": 3,
        //         "Name": "Joy & Peace",
        //         "Description": "Enjoy 10% off on regular-priced product, extra 5% off on discount-priced items",
        //         "From": "2022-01-01",
        //         "To": "2022-06-30",
        //         "ImageURL": "https://wraextprosto.z7.web.core.windows.net/295415F0-B649-EB11-A812-000D3A82FBCB_202012291719385687.jpg",
        //         "PosterImageURL": "",
        //         "Tags": "Shopping"
        //     },
        //     {
        //         "ExclusiveOfferId": "df7a48da-e762-ec11-8f8f-00224816ce4a",
        //         "MemberClub": 2,
        //         "MemberTier": "Black",
        //         "MemberTierId": "83bd3439-74e3-ea11-a813-000d3a8287a9",
        //         "Type": 3,
        //         "Name": "Jurlique",
        //         "Description": "Receive a Nutri-Define Supreme Skincare Travel Kit upon any purchase of regular-priced products of HK$2,500",
        //         "From": "2022-01-01",
        //         "To": "2022-06-30",
        //         "ImageURL": "https://wraextprosto.z7.web.core.windows.net/033F5581-ACD4-EB11-BACC-00224815FEB9_202106241325111662.jpg",
        //         "PosterImageURL": "",
        //         "Tags": "Shopping"
        //     },
        //     {
        //         "ExclusiveOfferId": "9064632a-e862-ec11-8f8f-00224816ce4a",
        //         "MemberClub": 2,
        //         "MemberTier": "Black",
        //         "MemberTierId": "83bd3439-74e3-ea11-a813-000d3a8287a9",
        //         "Type": 3,
        //         "Name": "JVG",
        //         "Description": "Purchase a digital water ionizer and receive a regular-priced gift worth HK$2,000",
        //         "From": "2022-01-01",
        //         "To": "2022-06-30",
        //         "ImageURL": "https://wraextprosto.z7.web.core.windows.net/1124266A-3962-EC11-8F8F-00224816CE4A_202202211207043657.jpg",
        //         "PosterImageURL": "",
        //         "Tags": "Shopping"
        //     },
        //     {
        //         "ExclusiveOfferId": "fd1c7db1-e862-ec11-8f8f-00224816ce4a",
        //         "MemberClub": 2,
        //         "MemberTier": "Black",
        //         "MemberTierId": "83bd3439-74e3-ea11-a813-000d3a8287a9",
        //         "Type": 3,
        //         "Name": "Kei Cuisine",
        //         "Description": "Upon any spending can enjoy a complimentary birthday cake OR Reserve private room with more than 8 people with free minimum room charge",
        //         "From": "2022-01-01",
        //         "To": "2022-06-30",
        //         "ImageURL": "https://wraextprosto.z7.web.core.windows.net/551AB0A0-3791-EB11-B1AC-00224815C794_202103301710128055.jpg",
        //         "PosterImageURL": "",
        //         "Tags": "Dining"
        //     },
        //     {
        //         "ExclusiveOfferId": "4effdbfd-e862-ec11-8f8f-00224816ce4a",
        //         "MemberClub": 2,
        //         "MemberTier": "Black",
        //         "MemberTierId": "83bd3439-74e3-ea11-a813-000d3a8287a9",
        //         "Type": 3,
        //         "Name": "LAFIT",
        //         "Description": "Enjoy 20% off on regular-priced goods at LAFIT Times Square store",
        //         "From": "2022-01-01",
        //         "To": "2022-06-30",
        //         "ImageURL": "https://wraextprosto.z7.web.core.windows.net/F3BF791E-6661-EC11-8F8F-00224816CE4A_202112201526408296.jpg",
        //         "PosterImageURL": "",
        //         "Tags": "Shopping"
        //     },
        //     {
        //         "ExclusiveOfferId": "9aeb9b3b-e962-ec11-8f8f-00224816ce4a",
        //         "MemberClub": 2,
        //         "MemberTier": "Black",
        //         "MemberTierId": "83bd3439-74e3-ea11-a813-000d3a8287a9",
        //         "Type": 3,
        //         "Name": "Loewe",
        //         "Description": "1. Enjoy local delivery services upon purchase over HKD 10,000. (Residential area)\n2. Enjoy reservation of specific merchandise up to 3 days\n3. Enjoy a complimentary welcome drink upon visit",
        //         "From": "2022-01-01",
        //         "To": "2022-06-30",
        //         "ImageURL": "https://wraextprosto.z7.web.core.windows.net/9B9A6EAC-94D5-EB11-BACC-00224815FEB9_202106251707047113.jpg",
        //         "PosterImageURL": "",
        //         "Tags": "Shopping"
        //     },
        //     {
        //         "ExclusiveOfferId": "e66bbc22-ea62-ec11-8f8f-00224816ce4a",
        //         "MemberClub": 2,
        //         "MemberTier": "Black",
        //         "MemberTierId": "83bd3439-74e3-ea11-a813-000d3a8287a9",
        //         "Type": 3,
        //         "Name": "LOG-ON",
        //         "Description": "Enjoy 3% discount on LOG-ON regular-price items",
        //         "From": "2022-01-01",
        //         "To": "2022-06-30",
        //         "ImageURL": "https://wraextprosto.z7.web.core.windows.net/C9F9013C-7061-EC11-8F8F-00224816CE4A_202112201639045625.jpg",
        //         "PosterImageURL": "",
        //         "Tags": "Shopping"
        //     },
        //     {
        //         "ExclusiveOfferId": "3d294f63-ea62-ec11-8f8f-00224816ce4a",
        //         "MemberClub": 2,
        //         "MemberTier": "Black",
        //         "MemberTierId": "83bd3439-74e3-ea11-a813-000d3a8287a9",
        //         "Type": 3,
        //         "Name": "Maje",
        //         "Description": "Receive a complimentary gift on upon the first time purchase on regular-priced items only",
        //         "From": "2022-01-01",
        //         "To": "2022-06-30",
        //         "ImageURL": "https://wracmsuatsto.blob.core.windows.net/assets/5e4e577deb27.jpg",
        //         "PosterImageURL": "",
        //         "Tags": "Shopping"
        //     },
        //     {
        //         "ExclusiveOfferId": "bab34e09-eb62-ec11-8f8f-00224816ce4a",
        //         "MemberClub": 2,
        //         "MemberTier": "Black",
        //         "MemberTierId": "83bd3439-74e3-ea11-a813-000d3a8287a9",
        //         "Type": 3,
        //         "Name": "Max Mara",
        //         "Description": "1. For Non-Max Mara VIP: Receive a Max Mara one-year VIP Membership upon net purchase of HK$15,000 on regular-priced items\n2. For Max Mara VIP: Receive a complimentary gift upon net purchase of HK15,000 on regular-priced items",
        //         "From": "2022-01-01",
        //         "To": "2022-06-30",
        //         "ImageURL": "https://wraextprosto.z7.web.core.windows.net/BC9E3BB6-7461-EC11-8F8F-00224816CE4A_202112201711053746.jpg",
        //         "PosterImageURL": "",
        //         "Tags": "Shopping"
        //     },
        //     {
        //         "ExclusiveOfferId": "4298de6b-eb62-ec11-8f8f-00224816ce4a",
        //         "MemberClub": 2,
        //         "MemberTier": "Black",
        //         "MemberTierId": "83bd3439-74e3-ea11-a813-000d3a8287a9",
        //         "Type": 3,
        //         "Name": "MAX&Co.",
        //         "Description": "Receive a complimentary gift upon net purchase of HK$5,000 on regular-priced items",
        //         "From": "2022-01-01",
        //         "To": "2022-06-30",
        //         "ImageURL": "https://wracmsuatsto.blob.core.windows.net/assets/Max%20_%20Co..jpg",
        //         "PosterImageURL": "",
        //         "Tags": "Shopping"
        //     },
        //     {
        //         "ExclusiveOfferId": "d6da0ce4-eb62-ec11-8f8f-00224816ce4a",
        //         "MemberClub": 2,
        //         "MemberTier": "Black",
        //         "MemberTierId": "83bd3439-74e3-ea11-a813-000d3a8287a9",
        //         "Type": 3,
        //         "Name": "Miller Harris",
        //         "Description": "1. To Receive 20% Off Discount in any purchase\n2. To receive a 2ml sample",
        //         "From": "2022-01-01",
        //         "To": "2022-06-30",
        //         "ImageURL": "https://wraextprosto.z7.web.core.windows.net/3E62FB7E-5E4A-EB11-A812-000D3A82FBCB_202012301319018628.jpg",
        //         "PosterImageURL": "",
        //         "Tags": "Shopping"
        //     },
        //     {
        //         "ExclusiveOfferId": "344a3a3b-ec62-ec11-8f8f-00224816ce4a",
        //         "MemberClub": 2,
        //         "MemberTier": "Black",
        //         "MemberTierId": "83bd3439-74e3-ea11-a813-000d3a8287a9",
        //         "Type": 3,
        //         "Name": "Millie’s",
        //         "Description": "Enjoy 10% off on regular-priced product, extra 5% off on discount-priced items",
        //         "From": "2022-01-01",
        //         "To": "2022-06-30",
        //         "ImageURL": "https://wraextprosto.z7.web.core.windows.net/537D1D8D-BB49-EB11-A812-000D3A82FBCB_202012291752460815.jpg",
        //         "PosterImageURL": "",
        //         "Tags": "Shopping"
        //     },
        //     {
        //         "ExclusiveOfferId": "a5e55ec1-ec62-ec11-8f8f-00224816ce4a",
        //         "MemberClub": 2,
        //         "MemberTier": "Black",
        //         "MemberTierId": "83bd3439-74e3-ea11-a813-000d3a8287a9",
        //         "Type": 3,
        //         "Name": "mtm labo",
        //         "Description": "1. Enjoy a complimentary skin analysis and assessment\n2. Enjoy 5% off on first purchase of [ custom-blended skincare ] products",
        //         "From": "2022-01-01",
        //         "To": "2022-06-30",
        //         "ImageURL": "https://wraextprosto.z7.web.core.windows.net/7FC5B2E9-5E4A-EB11-A812-000D3A82FBCB_202012301322025136.jpg",
        //         "PosterImageURL": "",
        //         "Tags": "Shopping"
        //     },
        //     {
        //         "ExclusiveOfferId": "06ec262d-ed62-ec11-8f8f-00224816ce4a",
        //         "MemberClub": 2,
        //         "MemberTier": "Black",
        //         "MemberTierId": "83bd3439-74e3-ea11-a813-000d3a8287a9",
        //         "Type": 3,
        //         "Name": "Optical 88",
        //         "Description": "Enjoy 10% off on regular-priced items",
        //         "From": "2022-01-01",
        //         "To": "2022-06-30",
        //         "ImageURL": "https://wraextprosto.z7.web.core.windows.net/4DBDE08D-1CF4-EB11-94EF-000D3A8043B3_202108031336391459.jpg",
        //         "PosterImageURL": "",
        //         "Tags": "Shopping"
        //     },
        //     {
        //         "ExclusiveOfferId": "c801e079-ed62-ec11-8f8f-00224816ce4a",
        //         "MemberClub": 2,
        //         "MemberTier": "Black",
        //         "MemberTierId": "83bd3439-74e3-ea11-a813-000d3a8287a9",
        //         "Type": 3,
        //         "Name": "OTO",
        //         "Description": "Member enjoy 7% off discount upon purchase of any regular priced product",
        //         "From": "2022-01-01",
        //         "To": "2022-06-30",
        //         "ImageURL": "https://wraextprosto.z7.web.core.windows.net/33D70243-BD49-EB11-A812-000D3A82FBCB_202012291804556483.jpg",
        //         "PosterImageURL": "",
        //         "Tags": "Shopping"
        //     },
        //     {
        //         "ExclusiveOfferId": "1ebf36ba-ed62-ec11-8f8f-00224816ce4a",
        //         "MemberClub": 2,
        //         "MemberTier": "Black",
        //         "MemberTierId": "83bd3439-74e3-ea11-a813-000d3a8287a9",
        //         "Type": 3,
        //         "Name": "Oyoné Paris",
        //         "Description": "Upon spending HK$500 on regular priced items in a single transaction to become our VIP enjoy 5% discount and extra 5% for VIC ",
        //         "From": "2022-01-01",
        //         "To": "2022-06-30",
        //         "ImageURL": "https://wraextprosto.z7.web.core.windows.net/D985E513-3F62-EC11-8F8F-00224816CE4A_202203031448044666.jpg",
        //         "PosterImageURL": "",
        //         "Tags": "Shopping"
        //     },
        //     {
        //         "ExclusiveOfferId": "f8e8fe63-ee62-ec11-8f8f-00224816ce4a",
        //         "MemberClub": 2,
        //         "MemberTier": "Black",
        //         "MemberTierId": "83bd3439-74e3-ea11-a813-000d3a8287a9",
        //         "Type": 3,
        //         "Name": "PizzaExpress",
        //         "Description": "Enjoy 15% off on a-la-carte menu",
        //         "From": "2022-01-01",
        //         "To": "2022-06-30",
        //         "ImageURL": "https://wracmsuatsto.blob.core.windows.net/assets/PizzaExpress.jpg",
        //         "PosterImageURL": "",
        //         "Tags": "Dining"
        //     },
        //     {
        //         "ExclusiveOfferId": "af6d47c6-ee62-ec11-8f8f-00224816ce4a",
        //         "MemberClub": 2,
        //         "MemberTier": "Black",
        //         "MemberTierId": "83bd3439-74e3-ea11-a813-000d3a8287a9",
        //         "Type": 3,
        //         "Name": "Planet J Hong Kong",
        //         "Description": "Entitle to a complimentary membership and HK$30 tokens (15pcs)",
        //         "From": "2022-01-01",
        //         "To": "2022-06-30",
        //         "ImageURL": "https://wracmsuatsto.blob.core.windows.net/assets/Planet%20J%20Hong%20Kong_Shop%20Front.jpg",
        //         "PosterImageURL": "",
        //         "Tags": "Shopping"
        //     },
        //     {
        //         "ExclusiveOfferId": "e0a64277-ef62-ec11-8f8f-00224816ce4a",
        //         "MemberClub": 2,
        //         "MemberTier": "Black",
        //         "MemberTierId": "83bd3439-74e3-ea11-a813-000d3a8287a9",
        //         "Type": 3,
        //         "Name": "POLA",
        //         "Description": "1. Enjoy Complimentary Skin Consultation Service* (15 mins), And receive POLA Hero Experience Kit after service\n2. Any Purchase of POLA products upon HK$2,500, enjoy complimentary B.A Lotion 8ml, B.A Wash 9g & B.A Grandluxe III 6g   ",
        //         "From": "2022-01-01",
        //         "To": "2022-06-30",
        //         "ImageURL": "https://wraextprosto.z7.web.core.windows.net/33AACD55-604A-EB11-A812-000D3A82FBCB_202012301332155439.jpg",
        //         "PosterImageURL": "",
        //         "Tags": "Shopping"
        //     },
        //     {
        //         "ExclusiveOfferId": "bf102cce-ef62-ec11-8f8f-00224816ce4a",
        //         "MemberClub": 2,
        //         "MemberTier": "Black",
        //         "MemberTierId": "83bd3439-74e3-ea11-a813-000d3a8287a9",
        //         "Type": 3,
        //         "Name": "Rituals",
        //         "Description": "Enjoy 10% discount upon net purchase of HK$500 or above on regular-priced items",
        //         "From": "2022-01-01",
        //         "To": "2022-06-30",
        //         "ImageURL": "https://wraextprosto.z7.web.core.windows.net/930A9CB2-604A-EB11-A812-000D3A82FBCB_202012301334506938.jpg",
        //         "PosterImageURL": "",
        //         "Tags": "Shopping"
        //     },
        //     {
        //         "ExclusiveOfferId": "6bb286ba-f962-ec11-8f8f-00224816ce4a",
        //         "MemberClub": 2,
        //         "MemberTier": "Black",
        //         "MemberTierId": "83bd3439-74e3-ea11-a813-000d3a8287a9",
        //         "Type": 3,
        //         "Name": "Rococo",
        //         "Description": "10% discount on regular priced items",
        //         "From": "2022-01-01",
        //         "To": "2022-06-30",
        //         "ImageURL": "",
        //         "PosterImageURL": "",
        //         "Tags": "Shopping"
        //     },
        //     {
        //         "ExclusiveOfferId": "a2ce0f0a-fa62-ec11-8f8f-00224816ce4a",
        //         "MemberClub": 2,
        //         "MemberTier": "Black",
        //         "MemberTierId": "83bd3439-74e3-ea11-a813-000d3a8287a9",
        //         "Type": 3,
        //         "Name": "Salvatore Ferragamo",
        //         "Description": "1. Enjoy local delivery service upon purchase of regular-priced items. \n2. Enjoy a private appointment service at store & reservation of specific merchandise for up to 3 days.\n3. Receive a complimentary gift upon net spending of HK$50,000",
        //         "From": "2022-01-01",
        //         "To": "2022-06-30",
        //         "ImageURL": "https://wraextprosto.z7.web.core.windows.net/DF65C50D-1A62-EC11-8F8F-00224816CE4A_202112211254397526.jpg",
        //         "PosterImageURL": "",
        //         "Tags": "Shopping"
        //     },
        //     {
        //         "ExclusiveOfferId": "80d82060-fa62-ec11-8f8f-00224816ce4a",
        //         "MemberClub": 2,
        //         "MemberTier": "Black",
        //         "MemberTierId": "83bd3439-74e3-ea11-a813-000d3a8287a9",
        //         "Type": 3,
        //         "Name": "Samsonite",
        //         "Description": "Enjoy 5% on regular-priced items (Travel accessories are not included)",
        //         "From": "2022-01-01",
        //         "To": "2022-06-30",
        //         "ImageURL": "https://wracmsuatsto.blob.core.windows.net/assets/Samsonite.jpg",
        //         "PosterImageURL": "",
        //         "Tags": "Shopping"
        //     },
        //     {
        //         "ExclusiveOfferId": "28619ca4-fa62-ec11-8f8f-00224816ce4a",
        //         "MemberClub": 2,
        //         "MemberTier": "Black",
        //         "MemberTierId": "83bd3439-74e3-ea11-a813-000d3a8287a9",
        //         "Type": 3,
        //         "Name": "Sandro",
        //         "Description": "Receive a complimentary gift on upon the first time purchase on regular-priced items only",
        //         "From": "2022-01-01",
        //         "To": "2022-06-30",
        //         "ImageURL": "https://wracmsuatsto.blob.core.windows.net/assets/5eaf95ae4649.jpg",
        //         "PosterImageURL": "",
        //         "Tags": "Shopping"
        //     },
        //     {
        //         "ExclusiveOfferId": "990a6df4-fa62-ec11-8f8f-00224816ce4a",
        //         "MemberClub": 2,
        //         "MemberTier": "Black",
        //         "MemberTierId": "83bd3439-74e3-ea11-a813-000d3a8287a9",
        //         "Type": 3,
        //         "Name": "SEKKISEI",
        //         "Description": "SEKKISEI MIYABI ULTIMATE TOP PRIVILEGE SKINCARE SET HK$1,420 (Worth: HK$2,157) and enjoy an exclusive service 《 SEKKISEI MIYABI ULTIMATE Hand Treatment 》 (15-20 mins)",
        //         "From": "2022-01-01",
        //         "To": "2022-06-30",
        //         "ImageURL": "https://wraextprosto.z7.web.core.windows.net/E59CC539-714A-EB11-A812-000D3A82FBCB_202012301533210361.jpg",
        //         "PosterImageURL": "",
        //         "Tags": "Shopping"
        //     },
        //     {
        //         "ExclusiveOfferId": "4cd3f937-fb62-ec11-8f8f-00224816ce4a",
        //         "MemberClub": 2,
        //         "MemberTier": "Black",
        //         "MemberTierId": "83bd3439-74e3-ea11-a813-000d3a8287a9",
        //         "Type": 3,
        //         "Name": "SHISEIDO",
        //         "Description": "ULTIMUNE Power Infusing Concentrate Set HK$1,050 (Worth: HK$1,830)",
        //         "From": "2022-01-01",
        //         "To": "2022-06-30",
        //         "ImageURL": "https://wracmsuatsto.blob.core.windows.net/assets/5cb6a9b5ab68.jpg",
        //         "PosterImageURL": "",
        //         "Tags": "Shopping"
        //     },
        //     {
        //         "ExclusiveOfferId": "4ef04284-fb62-ec11-8f8f-00224816ce4a",
        //         "MemberClub": 2,
        //         "MemberTier": "Black",
        //         "MemberTierId": "83bd3439-74e3-ea11-a813-000d3a8287a9",
        //         "Type": 3,
        //         "Name": "Sisley Paris",
        //         "Description": "New customers can enjoy the first trial of 90-min Supremya Anti-Aging Facial Treatment (valued at HK$2,500) with a deposit of HK$1,600",
        //         "From": "2022-01-01",
        //         "To": "2022-06-30",
        //         "ImageURL": "https://wraextprosto.z7.web.core.windows.net/8250871A-584A-EB11-A812-000D3A82FBCB_202012301233218820.jpg",
        //         "PosterImageURL": "",
        //         "Tags": "Shopping"
        //     },
        //     {
        //         "ExclusiveOfferId": "c6cc0017-fc62-ec11-8f8f-00224816ce4a",
        //         "MemberClub": 2,
        //         "MemberTier": "Black",
        //         "MemberTierId": "83bd3439-74e3-ea11-a813-000d3a8287a9",
        //         "Type": 3,
        //         "Name": "Skechers",
        //         "Description": "Get 15% off on regular-priced shoes items ",
        //         "From": "2022-01-01",
        //         "To": "2022-06-30",
        //         "ImageURL": "https://wraextprosto.z7.web.core.windows.net/73C12250-C149-EB11-A812-000D3A82FBCB_202012291834042164.jpg",
        //         "PosterImageURL": "",
        //         "Tags": "Shopping"
        //     },
        //     {
        //         "ExclusiveOfferId": "bcfe405c-fc62-ec11-8f8f-00224816ce4a",
        //         "MemberClub": 2,
        //         "MemberTier": "Black",
        //         "MemberTierId": "83bd3439-74e3-ea11-a813-000d3a8287a9",
        //         "Type": 3,
        //         "Name": "Staccato",
        //         "Description": "10% off on regular-priced items",
        //         "From": "2022-01-01",
        //         "To": "2022-06-30",
        //         "ImageURL": "https://wracmsuatsto.blob.core.windows.net/assets/Staccato.jpg",
        //         "PosterImageURL": "",
        //         "Tags": "Shopping"
        //     },
        //     {
        //         "ExclusiveOfferId": "5a9fc7a7-fc62-ec11-8f8f-00224816ce4a",
        //         "MemberClub": 2,
        //         "MemberTier": "Black",
        //         "MemberTierId": "83bd3439-74e3-ea11-a813-000d3a8287a9",
        //         "Type": 3,
        //         "Name": "Tea WG Boutique",
        //         "Description": "10% off on regular products upon purchase over $800",
        //         "From": "2022-01-01",
        //         "To": "2022-06-30",
        //         "ImageURL": "https://wraextprosto.z7.web.core.windows.net/DBCDDDA8-1F62-EC11-8F8F-00224816CE4A_202112211334403845.jpg",
        //         "PosterImageURL": "",
        //         "Tags": "Shopping"
        //     },
        //     {
        //         "ExclusiveOfferId": "26d90901-fd62-ec11-8f8f-00224816ce4a",
        //         "MemberClub": 2,
        //         "MemberTier": "Black",
        //         "MemberTierId": "83bd3439-74e3-ea11-a813-000d3a8287a9",
        //         "Type": 3,
        //         "Name": "The Barn",
        //         "Description": "Enjoy a 15% discount for Regular Products",
        //         "From": "2022-01-01",
        //         "To": "2022-06-30",
        //         "ImageURL": "https://wraextprosto.z7.web.core.windows.net/9DF8451F-4362-EC11-8F8F-00224816CE4A_202202211204033589.jpg",
        //         "PosterImageURL": "",
        //         "Tags": "Shopping"
        //     },
        //     {
        //         "ExclusiveOfferId": "2963d27f-fd62-ec11-8f8f-00224816ce4a",
        //         "MemberClub": 2,
        //         "MemberTier": "Black",
        //         "MemberTierId": "83bd3439-74e3-ea11-a813-000d3a8287a9",
        //         "Type": 3,
        //         "Name": "TIFFANY & CO.",
        //         "Description": "A complimentary machine engraving service upon any purchases of engravable items at Tiffany Times Square Store",
        //         "From": "2022-01-01",
        //         "To": "2022-06-30",
        //         "ImageURL": "https://wracmsuatsto.blob.core.windows.net/assets/Shop%20front.jpg",
        //         "PosterImageURL": "",
        //         "Tags": "Shopping"
        //     },
        //     {
        //         "ExclusiveOfferId": "e3a82ddd-fd62-ec11-8f8f-00224816ce4a",
        //         "MemberClub": 2,
        //         "MemberTier": "Black",
        //         "MemberTierId": "83bd3439-74e3-ea11-a813-000d3a8287a9",
        //         "Type": 3,
        //         "Name": "Tory Burch",
        //         "Description": "10% discount on regular priced items (excl. T Monogram Collection and flip flops)",
        //         "From": "2022-01-01",
        //         "To": "2022-06-30",
        //         "ImageURL": "https://wraextprosto.z7.web.core.windows.net/C75025BB-C149-EB11-A812-000D3A82FBCB_202012291836574734.jpg",
        //         "PosterImageURL": "",
        //         "Tags": "Shopping"
        //     },
        //     {
        //         "ExclusiveOfferId": "fdc0c232-fe62-ec11-8f8f-00224816ce4a",
        //         "MemberClub": 2,
        //         "MemberTier": "Black",
        //         "MemberTierId": "83bd3439-74e3-ea11-a813-000d3a8287a9",
        //         "Type": 3,
        //         "Name": "TSL Jewellery",
        //         "Description": "Receive a complimentary TSL watch (worth HK$480) upon purchase of HK$4,800 on any regular priced jewellery items",
        //         "From": "2022-01-01",
        //         "To": "2022-06-30",
        //         "ImageURL": "https://wracmsuatsto.blob.core.windows.net/assets/CT_shopfront_1920x1080.jpg",
        //         "PosterImageURL": "",
        //         "Tags": "Shopping"
        //     },
        //     {
        //         "ExclusiveOfferId": "18e8677e-fe62-ec11-8f8f-00224816ce4a",
        //         "MemberClub": 2,
        //         "MemberTier": "Black",
        //         "MemberTierId": "83bd3439-74e3-ea11-a813-000d3a8287a9",
        //         "Type": 3,
        //         "Name": "via il colpo hair & nail",
        //         "Description": "Enjoy 20% discount on hair and nail services for the first trial",
        //         "From": "2022-01-01",
        //         "To": "2022-06-30",
        //         "ImageURL": "https://wraextprosto.z7.web.core.windows.net/58E8DDE5-614A-EB11-A812-000D3A82FBCB_202012301343260632.jpg",
        //         "PosterImageURL": "",
        //         "Tags": "Shopping"
        //     },
        //     {
        //         "ExclusiveOfferId": "41162b0b-ff62-ec11-8f8f-00224816ce4a",
        //         "MemberClub": 2,
        //         "MemberTier": "Black",
        //         "MemberTierId": "83bd3439-74e3-ea11-a813-000d3a8287a9",
        //         "Type": 3,
        //         "Name": "Victorinox",
        //         "Description": "5% off on regular-priced items",
        //         "From": "2022-01-01",
        //         "To": "2022-06-30",
        //         "ImageURL": "https://wraextprosto.z7.web.core.windows.net/5601FC80-C249-EB11-A812-000D3A82FBCB_202012291842344399.jpg",
        //         "PosterImageURL": "",
        //         "Tags": "Shopping"
        //     },
        //     {
        //         "ExclusiveOfferId": "d460da62-ff62-ec11-8f8f-00224816ce4a",
        //         "MemberClub": 2,
        //         "MemberTier": "Black",
        //         "MemberTierId": "83bd3439-74e3-ea11-a813-000d3a8287a9",
        //         "Type": 3,
        //         "Name": "Vivienne Tam",
        //         "Description": "10% off upon purchase of HK$2,000 on regular priced items",
        //         "From": "2022-01-01",
        //         "To": "2022-06-30",
        //         "ImageURL": "https://wraextprosto.z7.web.core.windows.net/3C795221-2262-EC11-8F8F-00224816CE4A_202112211352262742.jpg",
        //         "PosterImageURL": "",
        //         "Tags": "Shopping"
        //     },
        //     {
        //         "ExclusiveOfferId": "502c85af-ff62-ec11-8f8f-00224816ce4a",
        //         "MemberClub": 2,
        //         "MemberTier": "Black",
        //         "MemberTierId": "83bd3439-74e3-ea11-a813-000d3a8287a9",
        //         "Type": 3,
        //         "Name": "Weekend Max Mara",
        //         "Description": "Receive a complimentary gift upon net purchase of HK$6,000 on regular-priced items",
        //         "From": "2022-01-01",
        //         "To": "2022-06-30",
        //         "ImageURL": "https://wracmsuatsto.blob.core.windows.net/assets/Weekend%20Max%20Mara.jpg",
        //         "PosterImageURL": "",
        //         "Tags": "Shopping"
        //     },
        //     {
        //         "ExclusiveOfferId": "e372ccd1-0063-ec11-8f8f-00224816ce4a",
        //         "MemberClub": 2,
        //         "MemberTier": "Black",
        //         "MemberTierId": "83bd3439-74e3-ea11-a813-000d3a8287a9",
        //         "Type": 3,
        //         "Name": "Woke Up Like This",
        //         "Description": "Enjoy 20% off on the purchase of Skin Need products",
        //         "From": "2022-01-01",
        //         "To": "2022-06-30",
        //         "ImageURL": "https://wraextprosto.z7.web.core.windows.net/E138C9D9-B2D4-EB11-BACC-00224815FEB9_202106241410335416.jpg",
        //         "PosterImageURL": "",
        //         "Tags": "Shopping"
        //     },
        //     {
        //         "ExclusiveOfferId": "0860807d-2f66-ec11-8f8f-00224816ce4a",
        //         "MemberClub": 2,
        //         "MemberTier": "Black",
        //         "MemberTierId": "83bd3439-74e3-ea11-a813-000d3a8287a9",
        //         "Type": 4,
        //         "Name": "3CE Stylenanda",
        //         "Description": "15% off on selected regular-priced items",
        //         "From": "2022-01-01",
        //         "To": "2022-06-30",
        //         "ImageURL": "https://wraextprosto.z7.web.core.windows.net/34728C9E-DC62-EC11-8F8F-00224816CE4A_202112221207338030.jpg",
        //         "PosterImageURL": "",
        //         "Tags": "Shopping"
        //     },
        //     {
        //         "ExclusiveOfferId": "41d09701-3066-ec11-8f8f-00224816ce4a",
        //         "MemberClub": 2,
        //         "MemberTier": "Black",
        //         "MemberTierId": "83bd3439-74e3-ea11-a813-000d3a8287a9",
        //         "Type": 4,
        //         "Name": "AAPE BY A BATHING APE®",
        //         "Description": "15% off on selected regular-priced items",
        //         "From": "2022-01-01",
        //         "To": "2022-06-30",
        //         "ImageURL": "https://wraextprosto.z7.web.core.windows.net/F019672F-4F4A-EB11-A812-000D3A82FBCB_202012301129265752.jpg",
        //         "PosterImageURL": "",
        //         "Tags": "Shopping"
        //     },
        //     {
        //         "ExclusiveOfferId": "b271e061-3066-ec11-8f8f-00224816ce4a",
        //         "MemberClub": 2,
        //         "MemberTier": "Black",
        //         "MemberTierId": "83bd3439-74e3-ea11-a813-000d3a8287a9",
        //         "Type": 4,
        //         "Name": "ARTĒ Madrid",
        //         "Description": "Receive a complimentary designated ARTE Madrid ring and enjoy a HK$500 shopping discount upon purchase of regular-priced item(s) in birthday month",
        //         "From": "2022-01-01",
        //         "To": "2022-06-30",
        //         "ImageURL": "https://wraextprosto.z7.web.core.windows.net/0877A4B7-4F4A-EB11-A812-000D3A82FBCB_202012301133184938.jpg",
        //         "PosterImageURL": "",
        //         "Tags": "Shopping"
        //     },
        //     {
        //         "ExclusiveOfferId": "a4d8abad-3066-ec11-8f8f-00224816ce4a",
        //         "MemberClub": 2,
        //         "MemberTier": "Black",
        //         "MemberTierId": "83bd3439-74e3-ea11-a813-000d3a8287a9",
        //         "Type": 4,
        //         "Name": "Bakebe",
        //         "Description": "Receive a complimentary Bakebe water bottle",
        //         "From": "2022-01-01",
        //         "To": "2022-06-30",
        //         "ImageURL": "https://wraextprosto.z7.web.core.windows.net/9F4CD413-AD49-EB11-A812-000D3A82FBCB_202012291609022714.jpg",
        //         "PosterImageURL": "",
        //         "Tags": "Shopping"
        //     },
        //     {
        //         "ExclusiveOfferId": "1fb2fef3-3066-ec11-8f8f-00224816ce4a",
        //         "MemberClub": 2,
        //         "MemberTier": "Black",
        //         "MemberTierId": "83bd3439-74e3-ea11-a813-000d3a8287a9",
        //         "Type": 4,
        //         "Name": "banchan & Cook",
        //         "Description": "Free Boneless Sweet & Spicy Fried Chicken 0 Half [valued $108]",
        //         "From": "2022-01-01",
        //         "To": "2022-06-30",
        //         "ImageURL": "https://wraextprosto.z7.web.core.windows.net/0530B948-AE49-EB11-A812-000D3A82FBCB_202012291617432427.jpg",
        //         "PosterImageURL": "",
        //         "Tags": "Dining"
        //     },
        //     {
        //         "ExclusiveOfferId": "20049e49-3166-ec11-8f8f-00224816ce4a",
        //         "MemberClub": 2,
        //         "MemberTier": "Black",
        //         "MemberTierId": "83bd3439-74e3-ea11-a813-000d3a8287a9",
        //         "Type": 4,
        //         "Name": "Clinique",
        //         "Description": "Receive a complimentary set of 5 pcs skincare travel kit (Worth $285) upon any purchase during birthday month",
        //         "From": "2022-01-01",
        //         "To": "2022-06-30",
        //         "ImageURL": "https://wraextprosto.z7.web.core.windows.net/62D76BE4-634A-EB11-A812-000D3A82FBCB_202012301357368551.jpeg",
        //         "PosterImageURL": "",
        //         "Tags": "Shopping"
        //     },
        //     {
        //         "ExclusiveOfferId": "70308d98-3166-ec11-8f8f-00224816ce4a",
        //         "MemberClub": 2,
        //         "MemberTier": "Black",
        //         "MemberTierId": "83bd3439-74e3-ea11-a813-000d3a8287a9",
        //         "Type": 4,
        //         "Name": "Club Monaco",
        //         "Description": "Enjoy one off 10% off upon spending $3800 or above on regular items in a single transaction in BIRTHDAY MONTH",
        //         "From": "2022-01-01",
        //         "To": "2022-06-30",
        //         "ImageURL": "https://wraextprosto.z7.web.core.windows.net/6C71E246-B049-EB11-A812-000D3A82FBCB_202012291631533665.jpg",
        //         "PosterImageURL": "",
        //         "Tags": "Shopping"
        //     },
        //     {
        //         "ExclusiveOfferId": "0748d0e4-3166-ec11-8f8f-00224816ce4a",
        //         "MemberClub": 2,
        //         "MemberTier": "Black",
        //         "MemberTierId": "83bd3439-74e3-ea11-a813-000d3a8287a9",
        //         "Type": 4,
        //         "Name": "ecco",
        //         "Description": "20% discount on regular handbags",
        //         "From": "2022-01-01",
        //         "To": "2022-06-30",
        //         "ImageURL": "https://wracmsdevsto.z23.web.core.windows.net/6A206AD2-EF44-EB11-A812-000D3A8241A6_202012231524117157.jpg",
        //         "PosterImageURL": "",
        //         "Tags": "Shopping"
        //     },
        //     {
        //         "ExclusiveOfferId": "7eaffdfb-6166-ec11-8f8f-00224816ce4a",
        //         "MemberClub": 2,
        //         "MemberTier": "Black",
        //         "MemberTierId": "83bd3439-74e3-ea11-a813-000d3a8287a9",
        //         "Type": 4,
        //         "Name": "ÉLÉVATIONE",
        //         "Description": "1. Redeem a complimentary Delux Sample Pack\n2. 50% off for Repair Collection mask\n3. Free 1 Classic Facial",
        //         "From": "2022-01-01",
        //         "To": "2022-06-30",
        //         "ImageURL": "https://wraextprosto.z7.web.core.windows.net/7167228D-5C4A-EB11-A812-000D3A82FBCB_202012301305024597.jpg",
        //         "PosterImageURL": "",
        //         "Tags": "Shopping"
        //     },
        //     {
        //         "ExclusiveOfferId": "6d45dd49-6266-ec11-8f8f-00224816ce4a",
        //         "MemberClub": 2,
        //         "MemberTier": "Black",
        //         "MemberTierId": "83bd3439-74e3-ea11-a813-000d3a8287a9",
        //         "Type": 4,
        //         "Name": "FIVE CM",
        //         "Description": "20% off on selected regular-priced items",
        //         "From": "2022-01-01",
        //         "To": "2022-06-30",
        //         "ImageURL": "https://wraextprosto.z7.web.core.windows.net/BF90C2BE-B349-EB11-A812-000D3A82FBCB_202012291656409126.jpg",
        //         "PosterImageURL": "",
        //         "Tags": "Shopping"
        //     },
        //     {
        //         "ExclusiveOfferId": "d0bcc495-6266-ec11-8f8f-00224816ce4a",
        //         "MemberClub": 2,
        //         "MemberTier": "Black",
        //         "MemberTierId": "83bd3439-74e3-ea11-a813-000d3a8287a9",
        //         "Type": 4,
        //         "Name": "Fred Perry",
        //         "Description": "20% off on selected regular-priced items",
        //         "From": "2022-01-01",
        //         "To": "2022-06-30",
        //         "ImageURL": "https://wraextprosto.z7.web.core.windows.net/AC0024E0-B449-EB11-A812-000D3A82FBCB_202012291704549134.jpg",
        //         "PosterImageURL": "",
        //         "Tags": "Shopping"
        //     },
        //     {
        //         "ExclusiveOfferId": "3dabcde6-6266-ec11-8f8f-00224816ce4a",
        //         "MemberClub": 2,
        //         "MemberTier": "Black",
        //         "MemberTierId": "83bd3439-74e3-ea11-a813-000d3a8287a9",
        //         "Type": 4,
        //         "Name": "Her own words",
        //         "Description": "Enjoy one-time 15% discount on regular-priced items during the birthday month",
        //         "From": "2022-01-01",
        //         "To": "2022-06-30",
        //         "ImageURL": "https://wraextprosto.z7.web.core.windows.net/8D287A65-1FF4-EB11-94EF-000D3A8043B3_202108041648590476.jpg",
        //         "PosterImageURL": "",
        //         "Tags": "Shopping"
        //     },
        //     {
        //         "ExclusiveOfferId": "54e2913a-6366-ec11-8f8f-00224816ce4a",
        //         "MemberClub": 2,
        //         "MemberTier": "Black",
        //         "MemberTierId": "83bd3439-74e3-ea11-a813-000d3a8287a9",
        //         "Type": 4,
        //         "Name": "Jurlique",
        //         "Description": "Receive a complimentary Jurlique 3 travel size product tailored for your skincare need upon any purchase",
        //         "From": "2022-01-01",
        //         "To": "2022-06-30",
        //         "ImageURL": "https://wraextprosto.z7.web.core.windows.net/033F5581-ACD4-EB11-BACC-00224815FEB9_202106241325111662.jpg",
        //         "PosterImageURL": "",
        //         "Tags": "Shopping"
        //     },
        //     {
        //         "ExclusiveOfferId": "47162691-6366-ec11-8f8f-00224816ce4a",
        //         "MemberClub": 2,
        //         "MemberTier": "Black",
        //         "MemberTierId": "83bd3439-74e3-ea11-a813-000d3a8287a9",
        //         "Type": 4,
        //         "Name": "JVG",
        //         "Description": "Any purchase of a shower head set can be upgraded to a shower gift box set. (Including: 1 shower head + 1 shower chain + 2 Body wash)",
        //         "From": "2022-01-01",
        //         "To": "2022-06-30",
        //         "ImageURL": "https://wraextprosto.z7.web.core.windows.net/1124266A-3962-EC11-8F8F-00224816CE4A_202202211207043657.jpg",
        //         "PosterImageURL": "",
        //         "Tags": "Shopping"
        //     },
        //     {
        //         "ExclusiveOfferId": "a4e0ebea-6366-ec11-8f8f-00224816ce4a",
        //         "MemberClub": 2,
        //         "MemberTier": "Black",
        //         "MemberTierId": "83bd3439-74e3-ea11-a813-000d3a8287a9",
        //         "Type": 4,
        //         "Name": "KAMIMURA JAPANESE BBQ",
        //         "Description": "Gifted free flow of alcoholic beverages /a cup of Häagen-Dazs",
        //         "From": "2022-01-01",
        //         "To": "2022-06-30",
        //         "ImageURL": "https://wraextprosto.z7.web.core.windows.net/654210F5-2466-EC11-8F8F-00224816CE4A_202112261622562502.jpg",
        //         "PosterImageURL": "",
        //         "Tags": "Dining"
        //     },
        //     {
        //         "ExclusiveOfferId": "229e647c-6466-ec11-8f8f-00224816ce4a",
        //         "MemberClub": 2,
        //         "MemberTier": "Black",
        //         "MemberTierId": "83bd3439-74e3-ea11-a813-000d3a8287a9",
        //         "Type": 4,
        //         "Name": "Kei Cuisine",
        //         "Description": "Complimentary one selected dessert and one iichiko green tea cocktail upon any spending during birthday month\n",
        //         "From": "2022-01-01",
        //         "To": "2022-06-30",
        //         "ImageURL": "https://wraextprosto.z7.web.core.windows.net/551AB0A0-3791-EB11-B1AC-00224815C794_202103301710128055.jpg",
        //         "PosterImageURL": "",
        //         "Tags": "Dining"
        //     },
        //     {
        //         "ExclusiveOfferId": "ba5567c4-6466-ec11-8f8f-00224816ce4a",
        //         "MemberClub": 2,
        //         "MemberTier": "Black",
        //         "MemberTierId": "83bd3439-74e3-ea11-a813-000d3a8287a9",
        //         "Type": 4,
        //         "Name": "LAFIT",
        //         "Description": "Enjoy 15% off on regular-priced goods at LAFIT Times Square store",
        //         "From": "2022-01-01",
        //         "To": "2022-06-30",
        //         "ImageURL": "https://wraextprosto.z7.web.core.windows.net/F3BF791E-6661-EC11-8F8F-00224816CE4A_202112201526408296.jpg",
        //         "PosterImageURL": "",
        //         "Tags": "Shopping"
        //     },
        //     {
        //         "ExclusiveOfferId": "68223320-6566-ec11-8f8f-00224816ce4a",
        //         "MemberClub": 2,
        //         "MemberTier": "Black",
        //         "MemberTierId": "83bd3439-74e3-ea11-a813-000d3a8287a9",
        //         "Type": 4,
        //         "Name": "Miller Harris",
        //         "Description": "Purchase any item within the birthday month to receive a Travel Set (Shampoo/ Conditioner / Body Wash / Body Lotion 50ml each)",
        //         "From": "2022-01-01",
        //         "To": "2022-06-30",
        //         "ImageURL": "https://wraextprosto.z7.web.core.windows.net/3E62FB7E-5E4A-EB11-A812-000D3A82FBCB_202012301319018628.jpg",
        //         "PosterImageURL": "",
        //         "Tags": "Shopping"
        //     },
        //     {
        //         "ExclusiveOfferId": "78c7f766-6566-ec11-8f8f-00224816ce4a",
        //         "MemberClub": 2,
        //         "MemberTier": "Black",
        //         "MemberTierId": "83bd3439-74e3-ea11-a813-000d3a8287a9",
        //         "Type": 4,
        //         "Name": "mtm labo",
        //         "Description": "1. Enjoy a complimentary skin analysis and assessment\n2. Enjoy 5% off on first purchase of [ custom-blended skincare ] products and 2x bonus credit",
        //         "From": "2022-01-01",
        //         "To": "2022-06-30",
        //         "ImageURL": "https://wraextprosto.z7.web.core.windows.net/7FC5B2E9-5E4A-EB11-A812-000D3A82FBCB_202012301322025136.jpg",
        //         "PosterImageURL": "",
        //         "Tags": "Shopping"
        //     },
        //     {
        //         "ExclusiveOfferId": "777831b5-6566-ec11-8f8f-00224816ce4a",
        //         "MemberClub": 2,
        //         "MemberTier": "Black",
        //         "MemberTierId": "83bd3439-74e3-ea11-a813-000d3a8287a9",
        //         "Type": 4,
        //         "Name": "Optical 88",
        //         "Description": "Enjoy 15% off on regular-priced items and receive one complimentary box of HOYA Lens Wipes (20 pcs)",
        //         "From": "2022-01-01",
        //         "To": "2022-06-30",
        //         "ImageURL": "https://wraextprosto.z7.web.core.windows.net/4DBDE08D-1CF4-EB11-94EF-000D3A8043B3_202108031336391459.jpg",
        //         "PosterImageURL": "",
        //         "Tags": "Shopping"
        //     },
        //     {
        //         "ExclusiveOfferId": "8aa99b37-6666-ec11-8f8f-00224816ce4a",
        //         "MemberClub": 2,
        //         "MemberTier": "Black",
        //         "MemberTierId": "83bd3439-74e3-ea11-a813-000d3a8287a9",
        //         "Type": 4,
        //         "Name": "OTO",
        //         "Description": "Member can get an OTO Back Soother (BS-006R) (valued at HK$499) during the month of birthday",
        //         "From": "2022-01-01",
        //         "To": "2022-06-30",
        //         "ImageURL": "https://wraextprosto.z7.web.core.windows.net/33D70243-BD49-EB11-A812-000D3A82FBCB_202012291804556483.jpg",
        //         "PosterImageURL": "",
        //         "Tags": "Shopping"
        //     },
        //     {
        //         "ExclusiveOfferId": "86abfa75-6666-ec11-8f8f-00224816ce4a",
        //         "MemberClub": 2,
        //         "MemberTier": "Black",
        //         "MemberTierId": "83bd3439-74e3-ea11-a813-000d3a8287a9",
        //         "Type": 4,
        //         "Name": "Oyoné Paris",
        //         "Description": "Enjoy 15% off upon spending HK$500 on regular priced items in a single transaction",
        //         "From": "2022-01-01",
        //         "To": "2022-06-30",
        //         "ImageURL": "https://wraextprosto.z7.web.core.windows.net/D985E513-3F62-EC11-8F8F-00224816CE4A_202203031448044666.jpg",
        //         "PosterImageURL": "",
        //         "Tags": "Shopping"
        //     },
        //     {
        //         "ExclusiveOfferId": "888ac3c3-6666-ec11-8f8f-00224816ce4a",
        //         "MemberClub": 2,
        //         "MemberTier": "Black",
        //         "MemberTierId": "83bd3439-74e3-ea11-a813-000d3a8287a9",
        //         "Type": 4,
        //         "Name": "POLA",
        //         "Description": "1. Enjoy Complimentary Skin Consultation Service* (15 mins), And receive POLA Hero 2-piece Deluxe Kit after service\n2. Receive exclusive POLA Birthday gift after joining Love POLA club and become POLA new Ruby/Black diamond VIP",
        //         "From": "2022-01-01",
        //         "To": "2022-06-30",
        //         "ImageURL": "https://wraextprosto.z7.web.core.windows.net/33AACD55-604A-EB11-A812-000D3A82FBCB_202012301332155439.jpg",
        //         "PosterImageURL": "",
        //         "Tags": "Shopping"
        //     },
        //     {
        //         "ExclusiveOfferId": "1a65731d-6766-ec11-8f8f-00224816ce4a",
        //         "MemberClub": 2,
        //         "MemberTier": "Black",
        //         "MemberTierId": "83bd3439-74e3-ea11-a813-000d3a8287a9",
        //         "Type": 4,
        //         "Name": "SEKKISEI",
        //         "Description": "Enjoy an exclusive service 《 SEKKISEI MIYABI ULTIMATE Hand Treatment 》(15-20 mins)",
        //         "From": "2022-01-01",
        //         "To": "2022-06-30",
        //         "ImageURL": "https://wraextprosto.z7.web.core.windows.net/E59CC539-714A-EB11-A812-000D3A82FBCB_202012301533210361.jpg",
        //         "PosterImageURL": "",
        //         "Tags": "Shopping"
        //     },
        //     {
        //         "ExclusiveOfferId": "ce2c0363-6766-ec11-8f8f-00224816ce4a",
        //         "MemberClub": 2,
        //         "MemberTier": "Black",
        //         "MemberTierId": "83bd3439-74e3-ea11-a813-000d3a8287a9",
        //         "Type": 4,
        //         "Name": "SHISEIDO",
        //         "Description": "Receive an extra Revitalizing and Firming Skincare Set upon purchase of HK$980 (value sets are included) in a single transaction in birthday month (Worth: HK$230)",
        //         "From": "2022-01-01",
        //         "To": "2022-06-30",
        //         "ImageURL": "https://wracmsuatsto.blob.core.windows.net/assets/5cb6a9b5ab68.jpg",
        //         "PosterImageURL": "",
        //         "Tags": "Shopping"
        //     },
        //     {
        //         "ExclusiveOfferId": "6b93d5b0-6766-ec11-8f8f-00224816ce4a",
        //         "MemberClub": 2,
        //         "MemberTier": "Black",
        //         "MemberTierId": "83bd3439-74e3-ea11-a813-000d3a8287a9",
        //         "Type": 4,
        //         "Name": "Sisley Paris",
        //         "Description": "Receive a 2-piece Beauty Birthday Kit including Phyto-Blanc Le Soin 4ml and SISLEŸA L’Intégral Anti-Âge Eye & Lip Contour Cream 2ml (worth HK$400)",
        //         "From": "2022-01-01",
        //         "To": "2022-06-30",
        //         "ImageURL": "https://wraextprosto.z7.web.core.windows.net/8250871A-584A-EB11-A812-000D3A82FBCB_202012301233218820.jpg",
        //         "PosterImageURL": "",
        //         "Tags": "Shopping"
        //     },
        //     {
        //         "ExclusiveOfferId": "aa47bbf9-6766-ec11-8f8f-00224816ce4a",
        //         "MemberClub": 2,
        //         "MemberTier": "Black",
        //         "MemberTierId": "83bd3439-74e3-ea11-a813-000d3a8287a9",
        //         "Type": 4,
        //         "Name": "Skechers",
        //         "Description": "Get $100 of upon net purchase of $500 ",
        //         "From": "2022-01-01",
        //         "To": "2022-06-30",
        //         "ImageURL": "https://wraextprosto.z7.web.core.windows.net/73C12250-C149-EB11-A812-000D3A82FBCB_202012291834042164.jpg",
        //         "PosterImageURL": "",
        //         "Tags": "Shopping"
        //     },
        //     {
        //         "ExclusiveOfferId": "aa9c5b47-6866-ec11-8f8f-00224816ce4a",
        //         "MemberClub": 2,
        //         "MemberTier": "Black",
        //         "MemberTierId": "83bd3439-74e3-ea11-a813-000d3a8287a9",
        //         "Type": 4,
        //         "Name": "Tea WG Boutique",
        //         "Description": "15% off on regular products upon purchase over $800 and to redeem 1 piece of Tea-Infused Patisseries OR 2 pieces Tea-Infused Macarons",
        //         "From": "2022-01-01",
        //         "To": "2022-06-30",
        //         "ImageURL": "https://wraextprosto.z7.web.core.windows.net/DBCDDDA8-1F62-EC11-8F8F-00224816CE4A_202112211334403845.jpg",
        //         "PosterImageURL": "",
        //         "Tags": "Shopping"
        //     },
        //     {
        //         "ExclusiveOfferId": "72833483-6866-ec11-8f8f-00224816ce4a",
        //         "MemberClub": 2,
        //         "MemberTier": "Black",
        //         "MemberTierId": "83bd3439-74e3-ea11-a813-000d3a8287a9",
        //         "Type": 4,
        //         "Name": "The Barn",
        //         "Description": "A free teaware gift set can be redeemed upon purchase of HK$2,000 after the birthday month discount (while stocks last)",
        //         "From": "2022-01-01",
        //         "To": "2022-06-30",
        //         "ImageURL": "https://wraextprosto.z7.web.core.windows.net/9DF8451F-4362-EC11-8F8F-00224816CE4A_202202211204033589.jpg",
        //         "PosterImageURL": "",
        //         "Tags": "Shopping"
        //     },
        //     {
        //         "ExclusiveOfferId": "1d14fad1-6866-ec11-8f8f-00224816ce4a",
        //         "MemberClub": 2,
        //         "MemberTier": "Black",
        //         "MemberTierId": "83bd3439-74e3-ea11-a813-000d3a8287a9",
        //         "Type": 4,
        //         "Name": "Woke Up Like This",
        //         "Description": "Receive a complimentary birthday Skin Need Hand Cream 40ml",
        //         "From": "2022-01-01",
        //         "To": "2022-06-30",
        //         "ImageURL": "https://wraextprosto.z7.web.core.windows.net/E138C9D9-B2D4-EB11-BACC-00224815FEB9_202106241410335416.jpg",
        //         "PosterImageURL": "",
        //         "Tags": "Shopping"
        //     },
        //     {
        //         "ExclusiveOfferId": "4298aca7-8c7a-ec11-8d21-0022481764f6",
        //         "MemberClub": 2,
        //         "MemberTier": "Black",
        //         "MemberTierId": "83bd3439-74e3-ea11-a813-000d3a8287a9",
        //         "Type": 3,
        //         "Name": "Qeelin",
        //         "Description": "Receive a complimentary gift upon spending of $50,000",
        //         "From": "2022-02-11",
        //         "To": "2022-06-30",
        //         "ImageURL": "",
        //         "PosterImageURL": "",
        //         "Tags": "Shopping"
        //     }
        // ]);
        axios.post(`${DOMAIN}?offer-list`, {
            Language: getLanguageIntByLocale(),
            MemberClub: memberClub,
            MemberTierId: memberTierId,
        }).then((response) => {
            const result = response.data as ResponseIType<OfferResponseType>;
            resolve(result.Data.ExclusiveOffers);
        }).catch((err: Error) => {
            console.error(err);
            reject(err);
        })
    })

const getEventList = (loginData: LoginResponseType, memberTierId: string) =>
    new Promise<EventType[]>((resolve, reject) => {
        // resolve([
        //     {
        //         "EventId": "b65aae64-ba88-ec11-93b0-000d3a80be8e",
        //         "IsFavourite": false,
        //         "IsNew": false,
        //         "IsSpecial": true,
        //         "IsPromotional": false,
        //         "EventTitle": "Temporary Closure of VIC Lounge",
        //         "StartDate": "",
        //         "EndDate": "",
        //         "StartPromotion": "2022-02-08 08:00:00",
        //         "EndPromotion": "2022-04-30 08:00:00",
        //         "EventURL": "https://wraextprosto.z7.web.core.windows.net/B65AAE64-BA88-EC11-93B0-000D3A80BE8E_202202081639171852.jpg",
        //         "ImageURL": "https://wraextprosto.z7.web.core.windows.net/B65AAE64-BA88-EC11-93B0-000D3A80BE8E_202202081639171852.jpg",
        //         "ImageDesc": "",
        //         "BannerURL": "https://wraextprosto.z7.web.core.windows.net/B65AAE64-BA88-EC11-93B0-000D3A80BE8E_202202081638528768.jpg",
        //         "BannerDesc": "",
        //         "BannerTitle": "",
        //         "EventTimeDetails": "",
        //         "Tags": "Activity|Promotion",
        //         "EnableEventRegistration": false,
        //         "MemberClubs": [
        //             "TS (VIC)",
        //             "TS (TVIC)"
        //         ],
        //         "MemberTiers": [
        //             "Basic",
        //             "Gold",
        //             "Black",
        //             "Basic"
        //         ],
        //         "WebviewControl": true
        //     },
        //     {
        //         "EventId": "3ab4f191-0e6e-ec11-8943-000d3a8178f3",
        //         "IsFavourite": false,
        //         "IsNew": false,
        //         "IsSpecial": true,
        //         "IsPromotional": false,
        //         "EventTitle": "Change of Service Hour of 5/F VIC Concierge",
        //         "StartDate": "",
        //         "EndDate": "",
        //         "StartPromotion": "2022-01-05 08:00:00",
        //         "EndPromotion": "2022-04-30 08:00:00",
        //         "EventURL": "https://wraextprosto.z7.web.core.windows.net/3AB4F191-0E6E-EC11-8943-000D3A8178F3_202203071638229468.jpg",
        //         "ImageURL": "https://wraextprosto.z7.web.core.windows.net/3AB4F191-0E6E-EC11-8943-000D3A8178F3_202203071638229468.jpg",
        //         "ImageDesc": "",
        //         "BannerURL": "https://wraextprosto.z7.web.core.windows.net/3AB4F191-0E6E-EC11-8943-000D3A8178F3_202201051802378608.jpg",
        //         "BannerDesc": "",
        //         "BannerTitle": "",
        //         "EventTimeDetails": "",
        //         "Tags": "Activity|Promotion",
        //         "EnableEventRegistration": false,
        //         "MemberClubs": [
        //             "TS (BVIC)",
        //             "TS (VIC)"
        //         ],
        //         "MemberTiers": [
        //             "Basic",
        //             "Gold",
        //             "Black",
        //             "Basic"
        //         ],
        //         "WebviewControl": true
        //     },
        //     {
        //         "EventId": "6fb264e6-185f-ec11-8f8f-002248171fbf",
        //         "IsFavourite": false,
        //         "IsNew": false,
        //         "IsSpecial": true,
        //         "IsPromotional": false,
        //         "EventTitle": "VIC Membership Privileges",
        //         "StartDate": "",
        //         "EndDate": "",
        //         "StartPromotion": "2021-12-16 08:00:00",
        //         "EndPromotion": "2022-12-31 08:00:00",
        //         "EventURL": "https://wraextprosto.z7.web.core.windows.net/6FB264E6-185F-EC11-8F8F-002248171FBF_202112171709123798.jpg",
        //         "ImageURL": "https://wraextprosto.z7.web.core.windows.net/6FB264E6-185F-EC11-8F8F-002248171FBF_202112171709123798.jpg",
        //         "ImageDesc": "",
        //         "BannerURL": "https://wraextprosto.z7.web.core.windows.net/6FB264E6-185F-EC11-8F8F-002248171FBF_202112171708589763.jpg",
        //         "BannerDesc": "",
        //         "BannerTitle": "",
        //         "EventTimeDetails": "",
        //         "Tags": "Activity|Promotion",
        //         "EnableEventRegistration": false,
        //         "MemberClubs": [
        //             "TS (VIC)"
        //         ],
        //         "MemberTiers": [
        //             "Basic",
        //             "Black",
        //             "Gold"
        //         ],
        //         "WebviewControl": true
        //     },
        //     {
        //         "EventId": "4574fdd9-a5eb-ea11-a815-000d3a8543bd",
        //         "IsFavourite": false,
        //         "IsNew": false,
        //         "IsSpecial": false,
        //         "IsPromotional": false,
        //         "EventTitle": "Welcome Offer",
        //         "StartDate": "2020-09-01 00:00:00",
        //         "EndDate": "",
        //         "StartPromotion": "2020-09-01 00:00:00",
        //         "EndPromotion": "2099-12-31 23:30:00",
        //         "EventURL": "",
        //         "ImageURL": "",
        //         "ImageDesc": "Welcome Offer",
        //         "BannerURL": "https://wraextprosto.z7.web.core.windows.net/8616AB80-67E7-EA11-A817-000D3A856750_202012310935335514.jpg",
        //         "BannerDesc": "Welcome Offer",
        //         "BannerTitle": "Welcome Offer",
        //         "EventTimeDetails": "",
        //         "Tags": "Activity|Promotion",
        //         "EnableEventRegistration": false,
        //         "MemberClubs": [
        //             "TS (VIC)"
        //         ],
        //         "MemberTiers": [
        //             "Black"
        //         ],
        //         "WebviewControl": false
        //     },
        //     {
        //         "EventId": "6707c600-a2a5-ec11-983f-00224817e3ab",
        //         "IsFavourite": false,
        //         "IsNew": false,
        //         "IsSpecial": true,
        //         "IsPromotional": false,
        //         "EventTitle": "VANDA",
        //         "StartDate": "",
        //         "EndDate": "",
        //         "StartPromotion": "2022-03-17 08:00:00",
        //         "EndPromotion": "2022-03-31 08:00:00",
        //         "EventURL": "https://wraextprosto.z7.web.core.windows.net/6707C600-A2A5-EC11-983F-00224817E3AB_202203171127047106.jpg",
        //         "ImageURL": "https://wraextprosto.z7.web.core.windows.net/6707C600-A2A5-EC11-983F-00224817E3AB_202203171127047106.jpg",
        //         "ImageDesc": "",
        //         "BannerURL": "https://wraextprosto.z7.web.core.windows.net/6707C600-A2A5-EC11-983F-00224817E3AB_202203171130492428.jpg",
        //         "BannerDesc": "",
        //         "BannerTitle": "",
        //         "EventTimeDetails": "",
        //         "Tags": "activity|Promotion",
        //         "EnableEventRegistration": false,
        //         "MemberClubs": [
        //             "TS (TVIC)",
        //             "TS (VIC)"
        //         ],
        //         "MemberTiers": [
        //             "Basic",
        //             "Basic",
        //             "Gold",
        //             "Black"
        //         ],
        //         "WebviewControl": true
        //     },
        //     {
        //         "EventId": "f52c01e7-387f-ec11-8d21-00224817449a",
        //         "IsFavourite": false,
        //         "IsNew": false,
        //         "IsSpecial": true,
        //         "IsPromotional": false,
        //         "EventTitle": "2022 Shopping Delight",
        //         "StartDate": "2022-01-01 08:00:00",
        //         "EndDate": "2022-12-31 22:30:00",
        //         "StartPromotion": "2022-01-27 08:00:00",
        //         "EndPromotion": "2022-12-31 22:30:00",
        //         "EventURL": "https://d15k2d11r6t6rl.cloudfront.net/public/users/Integrators/30362ec0-6160-4873-be5a-3b39551a5a27/5f55e38f47b88438b2d089b9/Black%20Card%202022%20Shopping%20Delight.jpg",
        //         "ImageURL": "https://d15k2d11r6t6rl.cloudfront.net/public/users/Integrators/30362ec0-6160-4873-be5a-3b39551a5a27/5f55e38f47b88438b2d089b9/Black%20Card%202022%20Shopping%20Delight.jpg",
        //         "ImageDesc": "",
        //         "BannerURL": "https://wraextprosto.z7.web.core.windows.net/F52C01E7-387F-EC11-8D21-00224817449A_202201271419277958.jpg",
        //         "BannerDesc": "",
        //         "BannerTitle": "",
        //         "EventTimeDetails": "",
        //         "Tags": "ActivityIPromotions",
        //         "EnableEventRegistration": false,
        //         "MemberClubs": [
        //             "TS (VIC)"
        //         ],
        //         "MemberTiers": [
        //             "Black"
        //         ],
        //         "WebviewControl": true
        //     }
        // ]);
        // MemberClub, Language, MemberTierId, MemberNo, SessionKey
        axios.post(`${DOMAIN}?event-list`, {
            Language: getLanguageIntByLocale(),
            MemberClub: loginData.MemberClub,
            MemberNo: loginData.MemberNo,
            SessionKey: loginData.SessionKey,
            MemberTierId: memberTierId,
        }).then((response) => {
            const result = response.data as ResponseIType<EventResponseType>;
            resolve(result.Data.Events);
        }).catch((err: Error) => {
            console.error(err);
            reject(err);
        })
    });

export const getDetail = <T>(
    type: string,
    id: string,
    memberClub?: number,
    memberNo?: string,
    sessionKey?: string,
) =>
    new Promise<T>((resolve, reject) => {
        if (type === 'privilege') type = 'offer';
        axios.post(`${DOMAIN}?${type}`, {
            Language: getLanguageIntByLocale(),
            id: id,
            MemberClub: memberClub,
            MemberNo: memberNo,
            SessionKey: sessionKey,
        }).then((response) => {
            const result = response.data as ResponseIType<T>;
            resolve(result.Data);
        }).catch((err: Error) => {
            console.error(err);
            reject(err);
        })
    })

export const getRewardDetail = (id: string) => getDetail<RewardDetailType>('reward', id);
export const getOfferDetail = (id: string) => getDetail<OfferDetailType>('offer', id);
export const getEventDetail = (id: string, memberClub: number) =>
    getDetail<EventDetailType>('event', id, memberClub);

export const getTnc = (memberClub: number, lang: string) => new Promise<MasterDataType>((resolve, reject) => {
    const mLanguage = lang === "sc" ? 3 : (lang == "zh" ? 2 : 1);
    axios.post(`${DOMAIN}?tnc`, {
        Language: mLanguage,
        MemberClub: memberClub,
    }).then((response) => {
        const result = response.data as ResponseIType<MasterDataType>;
        resolve(result.Data);
    }).catch((err: Error) => {
        console.error(err);
        reject(err);
    })
});

export const getDoc = (lang: string) => new Promise<any[]>((resolve, reject) => {
    axios.get(`${DOMAIN_ROOT}/docs/vic-${lang}.csv`)
        .then((res: any) => {
            try{
                csv({ flatKeys: true })
                    .fromString(res.data)
                    .then((csvRow)=>{
                        const result = csvRow.reduce((acc, v, i) => {
                            for (const [key, value] of Object.entries(v)) {
                                if (!acc[key]) acc[key] = [];
                                if (value) acc[key].push(value);
                            }
                            return acc;
                        }, {});
                        resolve(result);
                    })
            } catch (e: any) {
                reject(e);
            }

        }).catch(reject);
});

export const getTncDoc = async (type: number, lang: string): Promise<any> => {
    return (await axios.get(`${DOMAIN_ROOT}/docs/` +
        getVICPrefix(type).toLowerCase() + "victnc" + (lang || 'en') + ".html")).data
}
